
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4arST", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2aaa6fe4422fe8f2$export$7ff94717e4b66546 = ({ editorActions: editorActions, collabEditProvider: collabEditProvider, forceAwaitCommitLocalSteps: forceAwaitCommitLocalSteps = false, reason: reason })=>{
    // awaitCommitLocalSteps dictates whether we wait until all the user's local steps are committed to collab-service backend before
    // returning the document, or if we return document immediately
    return (0, $cozmU.useCallback)((awaitCommitLocalSteps = true)=>{
        return awaitCommitLocalSteps || !!forceAwaitCommitLocalSteps ? editorActions.getResolvedEditorState(reason) : collabEditProvider?.getCurrentState();
    }, [
        editorActions,
        collabEditProvider,
        forceAwaitCommitLocalSteps,
        reason
    ]);
};
module.exports["useGetCollabProviderState"] = $2aaa6fe4422fe8f2$export$7ff94717e4b66546;

});

parcelRegister("l3Dp5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $i7cz5 = parcelRequire("i7cz5");


var $cb6fO = parcelRequire("cb6fO");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $bqMNb = parcelRequire("bqMNb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $dLX9a = parcelRequire("dLX9a");

var $lABjq = parcelRequire("lABjq");


var $8G1o2 = parcelRequire("8G1o2");


var $9F9dn = parcelRequire("9F9dn");

/**
 * @generated SignedSource<<d52a1a00acaa81164bb8fa04e7265805>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8e82010916e4bf31$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePublishReadEditorOnboardingStateFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$8e82010916e4bf31$var$node.hash = "bc0f99d71f28b583e23f103ac8634d30";
var $8e82010916e4bf31$export$2e2bcd8739ae039 = $8e82010916e4bf31$var$node;


/**
 * @generated SignedSource<<05d0b32e5817205518fb96077cd7364b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $934e7215f54d8537$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePublishReadLabelsFragment",
    "selections": [
        {
            "concreteType": "PaginatedLabelList",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "label"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Content"
};
$934e7215f54d8537$var$node.hash = "bd62e6bdf52db98920b7aaccd17d29bd";
var $934e7215f54d8537$export$2e2bcd8739ae039 = $934e7215f54d8537$var$node;


/**
 * @generated SignedSource<<99ee4aea241a4f40e4b972b1b65847a3>>
 * @relayHash 5c3d27f98f8ff4a07ed5dcabf41b618e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74c8971eb51d59c41872874d3fc381abb352d5d550b613346407aaf101f42728
const $9dd255a8b6713057$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "moveRequest"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ncsStepVersion"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissions"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictionState"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictions"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schedulePublishDate"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressNotifyWatchers"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentBody",
                            "variableName": "content"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "minorEdit",
                            "variableName": "suppressNotifyWatchers"
                        },
                        {
                            "kind": "Variable",
                            "name": "moveRequest",
                            "variableName": "moveRequest"
                        },
                        {
                            "kind": "Variable",
                            "name": "ncsStepVersion",
                            "variableName": "ncsStepVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "permissions",
                            "variableName": "permissions"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictionState",
                            "variableName": "restrictionState"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictions",
                            "variableName": "restrictions"
                        },
                        {
                            "kind": "Variable",
                            "name": "schedulePublishDate",
                            "variableName": "schedulePublishDate"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionMessage",
                            "variableName": "message"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "confluenceContentInput"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "draft"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "success"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "message"
    }, v18 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublishUpdateBlogMutation",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateBlogPostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateBlogPost",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublishUpdateBlogMutation",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateBlogPostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateBlogPost",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v19 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5c3d27f98f8ff4a07ed5dcabf41b618e",
            "id": "74c8971eb51d59c41872874d3fc381abb352d5d550b613346407aaf101f42728",
            "metadata": {},
            "name": "usePublishUpdateBlogMutation",
            "operationKind": "mutation",
            "text": "mutation usePublishUpdateBlogMutation($contentId:ID!,$content:String!,$message:String,$spaceKey:String!,$suppressNotifyWatchers:Boolean,$ncsStepVersion:String!,$title:String!,$version:Int!,$schedulePublishDate:String,$moveRequest:ConfluenceMoveRequestInput,$restrictions:PageRestrictionsInput,$cloudId:ID!,$restrictionState:ConfluenceContentRestrictionStateInput,$permissions:ConfluenceContentPermissionsInput){confluence_updateBlogPost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,moveRequest:$moveRequest,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,spaceKey:$spaceKey,title:$title,version:$version,versionMessage:$message,restrictionState:$restrictionState,permissions:$permissions},status:\"draft\"}){success,content{space{name,id},id},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$9dd255a8b6713057$var$node.hash = "403dcae9319894e332650a21b7093b87";
var $9dd255a8b6713057$export$2e2bcd8739ae039 = $9dd255a8b6713057$var$node;


/**
 * @generated SignedSource<<6aa6b908484a5da17f90f81d3f53f8f1>>
 * @relayHash c162cdfbdf5bb9eb48734474012a790f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 910b9ca0dd453cef06156f9999eb599f293fe2c899a41983db58cac2d2c14788
const $81285a6b5cdfe7f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "moveRequest"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ncsStepVersion"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissions"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictionState"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictions"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schedulePublishDate"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressNotifyWatchers"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentBody",
                            "variableName": "content"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "minorEdit",
                            "variableName": "suppressNotifyWatchers"
                        },
                        {
                            "kind": "Variable",
                            "name": "moveRequest",
                            "variableName": "moveRequest"
                        },
                        {
                            "kind": "Variable",
                            "name": "ncsStepVersion",
                            "variableName": "ncsStepVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "permissions",
                            "variableName": "permissions"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictionState",
                            "variableName": "restrictionState"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictions",
                            "variableName": "restrictions"
                        },
                        {
                            "kind": "Variable",
                            "name": "schedulePublishDate",
                            "variableName": "schedulePublishDate"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionMessage",
                            "variableName": "message"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "confluenceContentInput"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "draft"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "success"
    }, v16 = {
        "kind": "ScalarField",
        "name": "status"
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "message"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublishUpdatePageMutation",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "ConfluenceUpdatePagePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updatePage",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublishUpdatePageMutation",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "ConfluenceUpdatePagePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updatePage",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c162cdfbdf5bb9eb48734474012a790f",
            "id": "910b9ca0dd453cef06156f9999eb599f293fe2c899a41983db58cac2d2c14788",
            "metadata": {},
            "name": "usePublishUpdatePageMutation",
            "operationKind": "mutation",
            "text": "mutation usePublishUpdatePageMutation($contentId:ID!,$content:String!,$message:String,$spaceKey:String!,$suppressNotifyWatchers:Boolean,$ncsStepVersion:String!,$title:String!,$version:Int!,$schedulePublishDate:String,$moveRequest:ConfluenceMoveRequestInput,$restrictions:PageRestrictionsInput,$cloudId:ID!,$restrictionState:ConfluenceContentRestrictionStateInput,$permissions:ConfluenceContentPermissionsInput){confluence_updatePage(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,moveRequest:$moveRequest,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,spaceKey:$spaceKey,title:$title,version:$version,versionMessage:$message,restrictionState:$restrictionState,permissions:$permissions},status:\"draft\"}){success,content{status,space{name,id},id},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$81285a6b5cdfe7f0$var$node.hash = "ceee81a84b894b5ca43c4dc1de97ec33";
var $81285a6b5cdfe7f0$export$2e2bcd8739ae039 = $81285a6b5cdfe7f0$var$node;






var $kSwu1 = parcelRequire("kSwu1");


var $9pRHz = parcelRequire("9pRHz");


var $9DHhW = parcelRequire("9DHhW");


var $79LXc = parcelRequire("79LXc");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $gQojb = parcelRequire("gQojb");


var $dYcT6 = parcelRequire("dYcT6");


var $1mHQU = parcelRequire("1mHQU");


var $hYoU4 = parcelRequire("hYoU4");


var $2wSyg = parcelRequire("2wSyg");


var $04e9M = parcelRequire("04e9M");





var $c0rhi = parcelRequire("c0rhi");


var $5cryL = parcelRequire("5cryL");

/**
 * @generated SignedSource<<bb14a76de0cc0cef2dd03d8605e67e6b>>
 * @relayHash 9c224d65096c7ebcd032758c59449512
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7ac7454e0f9398d0a31668be1eae7eed03b3e523c09470aee832d8ee14b47d4
const $9fee973f2344acdb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9c224d65096c7ebcd032758c59449512",
            "id": "e7ac7454e0f9398d0a31668be1eae7eed03b3e523c09470aee832d8ee14b47d4",
            "metadata": {},
            "name": "SetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation SetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$9fee973f2344acdb$var$node.hash = "69ff9399f6f631fded012361d38c9b30";
var $9fee973f2344acdb$export$2e2bcd8739ae039 = $9fee973f2344acdb$var$node;


/**
 * @generated SignedSource<<ff19befac3abec8e0d0f8ef33be07326>>
 * @relayHash 9a7e3b0fa5815086546e714dedc2793c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e96bad59f76ab1ca8828e689be59032a984eb87f9043764ef84b1f090a1ea76a
const $5f72f754a7eee03c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OnboardingEditorLabelsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OnboardingEditorLabelsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a7e3b0fa5815086546e714dedc2793c",
            "id": "e96bad59f76ab1ca8828e689be59032a984eb87f9043764ef84b1f090a1ea76a",
            "metadata": {},
            "name": "OnboardingEditorLabelsQuery",
            "operationKind": "query",
            "text": "query OnboardingEditorLabelsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,labels{nodes{id,label}}}}}"
        }
    };
}();
$5f72f754a7eee03c$var$node.hash = "713a484a190fc43162623136c80d978b";
var $5f72f754a7eee03c$export$2e2bcd8739ae039 = $5f72f754a7eee03c$var$node;



var $8Z78B = parcelRequire("8Z78B");


var $ivb8S = parcelRequire("ivb8S");


var $ij4CE = parcelRequire("ij4CE");


var $6s78L = parcelRequire("6s78L");

const $ac5cee5bdff9fad4$export$d8f9e442caa9fb36 = ()=>{
    (0, $6s78L.mutateInterop)({
        mutation: (0, $9fee973f2344acdb$export$2e2bcd8739ae039),
        variables: {
            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
            value: 'true'
        },
        optimisticResponse: {
            onboardingState: [
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                    value: 'true',
                    __typename: 'OnboardingState'
                }
            ]
        },
        update () {
            (0, $ij4CE.writeFragmentInterop)({
                // fragmentId follows the Apollo cache key format: `TypeName:id`.
                // OnboardingState objects are cached by their `key` field as the id
                // (see getEditorOnboardingCache where readEditorOnboardingState is called with { id: key }).
                // This mirrors how liveDocSmartCardResolver uses `Content:${contentId}`.
                fragmentId: `OnboardingState:${(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED}`,
                data: {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                    value: 'true',
                    __typename: 'OnboardingState'
                },
                __callerPackage__: "@confluence/onboarding-helpers"
            });
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $ac5cee5bdff9fad4$var$queryVariables = {
    key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
};
const $ac5cee5bdff9fad4$export$df81c9f5e9f58f6f = ()=>{
    // When centralized onboarding state is enabled, skip this query as the centralized preloader handles it
    if ((0, $6mKj3.expValEquals)('confluence_centralized_onboarding_state', 'isEnabled', true)) return;
    (0, $c0rhi.queryInterop)({
        query: (0, $8Z78B.default),
        variables: $ac5cee5bdff9fad4$var$queryVariables,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $ac5cee5bdff9fad4$export$b2c224961b725273 = (readEditorOnboardingState)=>{
    try {
        let cachedEditorOnboardingData;
        const editorKeys = Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS));
        // each onboarding item is stored with the key as the cache id
        cachedEditorOnboardingData = editorKeys.map((id)=>readEditorOnboardingState({
                id: id
            }));
        // reformat to match query shape
        cachedEditorOnboardingData = {
            onboardingState: cachedEditorOnboardingData
        };
        const state = (0, $ivb8S.deserializeState)(cachedEditorOnboardingData);
        return state;
    } catch (cacheError) {
        // fire analytics
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'OnboardingState',
                actionSubject: 'getEditorOnboardingCache',
                action: 'failed',
                attributes: {
                    error: cacheError
                }
            });
        });
        // if cache is empty then call query to load cache
        $ac5cee5bdff9fad4$export$df81c9f5e9f58f6f();
        // return default state on error
        return {};
    }
};
const $ac5cee5bdff9fad4$export$9e94177ea23c227e = (contentId)=>{
    (0, $c0rhi.queryInterop)({
        query: (0, $5f72f754a7eee03c$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $ac5cee5bdff9fad4$export$823364ce80d725a7 = (contentId, readLabelsFragment)=>{
    try {
        const labels = readLabelsFragment({
            id: `Content:${contentId}`
        })?.nodes || [];
        // purposely exclude creator onboarding label as this is used for hiding the publish flag
        return labels && Boolean(labels.find((label)=>label?.label === (0, $5cryL.ONBOARDING_TUTORIAL_LABEL)));
    } catch (cacheError) {
        // fire analytics
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'LabelsQuery',
                actionSubject: 'getEditorLabelsQueryCache',
                action: 'failed',
                attributes: {
                    error: cacheError
                }
            });
        });
        // if cache is empty then call query to load cache
        $ac5cee5bdff9fad4$export$9e94177ea23c227e(contentId);
        // return false on error
        return false;
    }
};








var $dz5dy = parcelRequire("dz5dy");


var $bQm3c = parcelRequire("bQm3c");


var $8FvpY = parcelRequire("8FvpY");

var $6LguK = parcelRequire("6LguK");


var $18vK6 = parcelRequire("18vK6");


var $bPoXA = parcelRequire("bPoXA");


var $jmjWc = parcelRequire("jmjWc");


const $e4ac836f115646bd$export$abca55d634d2e553 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0x46P",
    name: "LazyWhiteBoardPublishDiscoveryDialog",
    loader: async ()=>(await (parcelRequire("biTuX"))).WhiteBoardPublishDiscoveryDialog
});






const $e46dcb986a461856$export$8b23712115c25226 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qKq0F",
    name: "LazyJiraLinkAutomationDiscoveryDialog",
    loader: async ()=>(await (parcelRequire("2uyII"))).JiraLinkAutomationDiscoveryDialog
});








var $f4L8J = parcelRequire("f4L8J");


const $28e13e40d3bc36a0$export$10eabf8fa127a1ac = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "nADL6",
    name: "LazyReleaseNotesPublishDiscoveryDialog",
    loader: async ()=>(await Promise.resolve((parcelRequire("f4L8J")))).ReleaseNotesDialog
});








var $ekkfU = parcelRequire("ekkfU");


const $26b5830c490d8616$export$2b5a9d8588be205e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FirLe",
    name: "LazyFeedbackAnalysisDiscoveryDialog",
    loader: async ()=>(await Promise.resolve((parcelRequire("ekkfU")))).FeedbackAnalysisDialog
});








var $9wXqm = parcelRequire("9wXqm");


const $92551eab53850ddc$export$bbd0e35c0a1b0e83 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "a8JLk",
    name: "LazyProductRequirementsPublishDiscoveryDialog",
    loader: async ()=>(await Promise.resolve((parcelRequire("9wXqm")))).ProductRequirementsDialog
});



var $5ueVa = parcelRequire("5ueVa");


var $llqlc = parcelRequire("llqlc");

/**
 * Below RegExp patterns taken from:
 * `jira-object-provider/src/patterns/index.ts`.
 * ---------------------------------------------
 * Note: This is originally intended to detect when a user pastes a jira link into the editor.
 * We don't need to be as specific as jira-object-provider, so we've omitted several patterns.
 * In many cases, it is suficient to just check the pasted URL using: pastedItem.indexOf('/jira/') >= 0
 */ // Returns the issue key if the URL is a valid Jira issue URL. It may also include a trailing
// hash fragment. A matching URL must look like: <host><baseurl>/browse/<issuekey><#hash?>.
// e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
const $0717d343d1ada114$var$issueKeyPattern = '[a-zA-Z0-9]+-\\d+';
const $0717d343d1ada114$var$jiraIssueContentIdParseStr = `\\/browse\\/(?<resourceId>${$0717d343d1ada114$var$issueKeyPattern})#?.*?\\/?$`;
const $0717d343d1ada114$var$jiraIssueContentIdParse = new RegExp($0717d343d1ada114$var$jiraIssueContentIdParseStr);
// For Jira Service Desk work portals.
// Examples:
// * https://jdog.jira-dev.com/servicedesk/customer/portal/223/NICK-7?created=true
// * https://jdog.jira-dev.com/servicedesk/projects/NICK/queues/custom/1698/NICK-7
// * https://jdog.jira-dev.com/jira/servicedesk/projects/NICK/queues/custom/1698/NICK-7
// * https://jdog.jira-dev.com/jira/servicedesk/projects/NICK/queues/issue/NICK-7
// * https://jdog.jira-dev.com/jira/servicedesk/projects/WOOH/section/incidents/custom/272/WOOH-15
// * https://spartans.jira-dev.com/helpcenter/2/portal/23/BIREN-30?created=true
// * https://spartans.jira-dev.com/helpcenter/slug/portal/23/BIREN-30
const $0717d343d1ada114$var$jiraPortalIdStr = `(\\/jira)?\\/servicedesk\\/customer\\/portal\\/\\d+\\/${$0717d343d1ada114$var$issueKeyPattern}\\/?.*$`;
const $0717d343d1ada114$var$jiraPortalIdParse = new RegExp($0717d343d1ada114$var$jiraPortalIdStr);
const $0717d343d1ada114$var$jiraPortalQueueIdStr = `(\\/jira)?\\/servicedesk\\/projects\\/[\\w]*\\/queues\\/(custom|issue)\\/(\\d+\\/)?${$0717d343d1ada114$var$issueKeyPattern}\\/?.*$`;
const $0717d343d1ada114$var$jiraPortalQueueIdParse = new RegExp($0717d343d1ada114$var$jiraPortalQueueIdStr);
const $0717d343d1ada114$var$jiraPortalSectionIdStr = `(\\/jira)?\\/servicedesk\\/projects\\/[\\w]*\\/section\\/(incidents|changes|service-requests|problems)\\/custom\\/\\d+\\/${$0717d343d1ada114$var$issueKeyPattern}\\/?.*$`;
const $0717d343d1ada114$var$jiraPortalSectionIdParse = new RegExp($0717d343d1ada114$var$jiraPortalSectionIdStr);
const $0717d343d1ada114$var$jiraAdvancedHelpCenterPortalIdStr = `(\\/jira)?\\/helpcenter\\/[\\w-]+\\/portal\\/\\d+\\/${$0717d343d1ada114$var$issueKeyPattern}\\/?.*$`;
const $0717d343d1ada114$var$jiraAdvancedHelpCenterPortalIdParse = new RegExp($0717d343d1ada114$var$jiraAdvancedHelpCenterPortalIdStr);
// https://softwareteams.atlassian.net/projects/SAI/versions/12505/tab/release-report-all-issues
// https://hello.atlassian.net/projects/BUILDENG/versions/44334/tab/release-report-all-issues
const $0717d343d1ada114$var$jiraVersionIdPattern = `\\/projects\\/[^\\/]+?\\/versions\\/\\d+\\/?`;
const $0717d343d1ada114$var$jiraVersionParse = new RegExp($0717d343d1ada114$var$jiraVersionIdPattern);
// https://abocan-test-1.jira-dev.com/browse/CHEES
const $0717d343d1ada114$var$jiraProjectIdPattern = `\\/browse\\/[^#\\/\?]+(\\#[^\\/]*?)?(\\?[^\\/]*?)?$`;
const $0717d343d1ada114$var$jiraProjectIdParse = new RegExp($0717d343d1ada114$var$jiraProjectIdPattern);
// https://jdog.jira-dev.com/issues/?jql=project%20%3D%20%22ADIL%22%20ORDER%20BY%20created%20DESC
const $0717d343d1ada114$var$jiraIssueJqlPattern = `\\/issues\\/.*?(\\&|\\?)(?!.*filter=)jql=[^&]*`;
const $0717d343d1ada114$var$jiraIssueJqlParse = new RegExp($0717d343d1ada114$var$jiraIssueJqlPattern);
const $0717d343d1ada114$var$jiraURLRegExps = [
    $0717d343d1ada114$var$jiraIssueContentIdParse,
    $0717d343d1ada114$var$jiraPortalIdParse,
    $0717d343d1ada114$var$jiraPortalQueueIdParse,
    $0717d343d1ada114$var$jiraPortalSectionIdParse,
    $0717d343d1ada114$var$jiraAdvancedHelpCenterPortalIdParse,
    $0717d343d1ada114$var$jiraVersionParse,
    $0717d343d1ada114$var$jiraProjectIdParse,
    $0717d343d1ada114$var$jiraIssueJqlParse
];
const $0717d343d1ada114$var$isJiraExtension = (node)=>{
    return node.type === 'extension' && node.attrs?.extensionKey === 'jira';
};
const $0717d343d1ada114$var$isJiraInlineCard = (node)=>{
    if (node.type === 'inlineCard') {
        // according to ADF API, either url or data.url will be present but not both
        const url = node?.attrs?.url || node?.attrs?.data?.url;
        return $0717d343d1ada114$export$9a3ac7e580aa77d2(url);
    }
    return false;
};
const $0717d343d1ada114$var$isJiraLink = (node)=>{
    if (!node.marks) return false;
    const linkMark = node.marks.filter((mark)=>mark.type === 'link')[0];
    return $0717d343d1ada114$export$9a3ac7e580aa77d2(linkMark?.attrs?.href);
};
const $0717d343d1ada114$export$246914ca6c1b255a = (editorContent)=>{
    const jiraNodes = (0, $llqlc.filter)(editorContent, (node)=>$0717d343d1ada114$var$isJiraExtension(node) || $0717d343d1ada114$var$isJiraInlineCard(node) || $0717d343d1ada114$var$isJiraLink(node));
    return jiraNodes.length > 0;
};
const $0717d343d1ada114$export$9a3ac7e580aa77d2 = (url)=>{
    if (!url) return false;
    const isAtlassianURL = url.match(/atlassian\.net|jira\.com/);
    const doesUrlContainJira = isAtlassianURL && url.indexOf('/jira/') >= 0;
    const doesUrlHaveJiraIssue = Boolean(isAtlassianURL && url.match(/\/browse\/[a-zA-Z][a-zA-Z0-9]{0,9}-[0-9]+/));
    if (doesUrlContainJira || doesUrlHaveJiraIssue) return true;
    for (const regExp of $0717d343d1ada114$var$jiraURLRegExps){
        if (regExp.test(url)) return true;
    }
    return false;
};







const $5ce33797797432c2$export$e2477c5ccf2a6633 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Wsth_",
    name: "LazyPagePublishAutomationDiscoveryDialog",
    loader: async ()=>(await (parcelRequire("gibc0"))).PagePublishAutomationDiscoveryDialog
});



var $euL71 = parcelRequire("euL71");




var $8Vmxc = parcelRequire("8Vmxc");







var $6fil2 = parcelRequire("6fil2");


var $jroIa = parcelRequire("jroIa");


var $kdpMy = parcelRequire("kdpMy");


var $3jwuS = parcelRequire("3jwuS");

/* showPublishSuccessFlagsWithSocialAndCopyLink.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $hekY6 = parcelRequire("hekY6");










const $8e565cc691ed7120$export$b06ad34367ea1e7b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.8418 5.44957L13.8243 5.44434L4.64062 14.985L4.64673 15.0016L19.6376 20.2301L13.8418 5.44957Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.33767 1.60522L8.34276 5.45308L3.27832 4.64668L3.30712 3.1613L3.33767 1.60522Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.6558 7.90377H10.9139L9.20508 2.82275H10.947L12.6558 7.90377Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.42836 13.8565L7.40131 13.7841C7.24596 13.3739 6.97891 13.0231 6.62807 12.7708C6.27025 12.5134 5.8496 12.3772 5.41149 12.3772C4.97338 12.3772 4.5536 12.5134 4.19491 12.7708C3.84407 13.0231 3.57702 13.3739 3.42167 13.7841L3.39462 13.8565H1.84814L1.87956 13.7195C2.06545 12.9131 2.51404 12.1818 3.14327 11.6607C3.45833 11.3998 3.81004 11.1973 4.18793 11.0568C4.57978 10.9119 4.99084 10.8386 5.41062 10.8386C5.8304 10.8386 6.24145 10.9119 6.63331 11.0568C7.01207 11.1964 7.36291 11.3998 7.67796 11.6607C8.30719 12.1818 8.75578 12.9131 8.94167 13.7195L8.97309 13.8565H7.42836Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.53799 8.70059C4.59123 8.65521 4.64272 8.60197 4.69159 8.54262C4.74047 8.48328 4.78323 8.42044 4.81814 8.35761C5.02323 7.98844 4.96214 7.60706 4.68985 7.29986C4.64359 7.2475 4.59123 7.19688 4.53276 7.14975C4.47428 7.10262 4.4097 7.05724 4.34599 7.02059C3.98905 6.81637 3.60417 6.83208 3.28476 7.10437C3.23065 7.15062 3.17828 7.20386 3.12854 7.26495C3.07967 7.32517 3.03777 7.38626 3.00374 7.44735C2.79952 7.8139 2.86148 8.19441 3.1329 8.50422C3.1809 8.55921 3.23501 8.61157 3.2961 8.66132C3.35719 8.71106 3.41828 8.75382 3.47937 8.78873C3.83544 8.99208 4.21944 8.97724 4.53799 8.70059Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.64 11.4008C11.6933 11.3554 11.7448 11.3022 11.7936 11.2428C11.8425 11.1835 11.8853 11.1206 11.9202 11.0578C12.1253 10.6886 12.0642 10.3073 11.7919 10.0001C11.7456 9.94769 11.6933 9.89707 11.6348 9.84995C11.5763 9.80282 11.5118 9.75744 11.448 9.72078C11.0911 9.51657 10.7062 9.53227 10.3868 9.80457C10.3327 9.85082 10.2803 9.90406 10.2306 9.96515C10.1808 10.0262 10.1398 10.0865 10.1058 10.1475C9.90157 10.5141 9.96353 10.8946 10.235 11.2044C10.283 11.2594 10.3371 11.3118 10.3982 11.3615C10.4593 11.4113 10.5204 11.454 10.5814 11.4889C10.9375 11.6923 11.3215 11.6775 11.64 11.4008Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.40029 13.7842L7.42734 13.8567H8.97382L8.9424 13.7197C8.76611 12.9517 8.34982 12.2517 7.76683 11.7368L6.70996 12.8356C7.01978 13.0817 7.25803 13.4072 7.40029 13.7842Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.6557 7.90381L12.345 6.98047L11.4565 7.90381H12.6557Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.70233 7.31836L6.89453 8.979L8.55517 9.7868L9.36297 8.12616L7.70233 7.31836Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.01745 9.92587C3.03404 9.91104 3.05062 9.90318 3.06807 9.89097C3.08553 9.88486 3.10385 9.87264 3.12393 9.87089C3.12393 9.87089 3.13702 9.87264 3.15709 9.87613C3.17716 9.88398 3.20509 9.88922 3.23302 9.90406C3.28975 9.92849 3.33775 9.97911 3.38138 10.0131C3.432 10.1249 3.44073 10.2593 3.4992 10.3954C3.4992 10.3954 3.52189 10.4364 3.56204 10.4757C3.60306 10.5141 3.66065 10.5411 3.69207 10.5385C3.73135 10.5342 3.75578 10.5193 3.76625 10.5001C3.77673 10.4809 3.77324 10.4574 3.7584 10.4364C3.7584 10.4364 3.73922 10.4076 3.70954 10.369C3.67898 10.3308 3.63972 10.2819 3.60917 10.2132C3.5499 10.0805 3.56378 9.9374 3.45034 9.83007C3.45034 9.83007 3.41806 9.79866 3.37791 9.77423C3.33775 9.74979 3.28975 9.73233 3.26095 9.73844C3.22343 9.74717 3.20334 9.76637 3.19636 9.78819C3.18938 9.81001 3.19462 9.83444 3.20946 9.85277C3.20946 9.85277 3.01745 9.92587 3.01745 9.92587Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.75714 2.66635C7.77896 2.66025 7.79728 2.66199 7.81823 2.6585C7.83656 2.66112 7.85925 2.6585 7.87757 2.66635C7.87757 2.66635 7.88805 2.67421 7.90463 2.68555C7.91947 2.70126 7.94216 2.71872 7.95961 2.7449C7.99888 2.7929 8.01808 2.8601 8.04252 2.90984C8.03728 3.0329 7.98317 3.15595 7.97357 3.30432C7.97357 3.30432 7.97532 3.35144 7.99277 3.40468C8.01197 3.45792 8.05125 3.50766 8.08005 3.51901C8.1167 3.53297 8.1455 3.53123 8.16383 3.51901C8.18128 3.50679 8.19001 3.4841 8.18565 3.45879C8.1795 3.45879 7.75714 2.66635 7.75714 2.66635Z",
        fill: "#101214"
    }));









var $bcDqz = parcelRequire("bcDqz");


var $dinVW = parcelRequire("dinVW");

const $26ba4073e3f27460$var$i18n = (0, $kSwu1.defineMessages)({
    publishSuccessMessageWithSpaceName: {
        id: "editor-features.user.publish.success.with.space.name",
        defaultMessage: "{pageTitle} was successfully published in the {spaceName} space"
    },
    publishSuccessMessage: {
        id: "editor-features.user.publish.success",
        defaultMessage: "{pageTitle} was successfully published"
    },
    publishSuccessMessageWithSocial: {
        id: "editor-features.publish.success.message.with.social",
        defaultMessage: "Share this page to ensure your team can see and build on your contributions."
    }
});
const $26ba4073e3f27460$export$8c6a25f4516e16d9 = ({ intl: intl, title: title, spaceName: spaceName, suggestedUsers: suggestedUsers = [], showSocial: showSocial })=>{
    const avatarGroupData = (0, $cozmU.useMemo)(()=>(suggestedUsers || []).reduce((users, currentUser)=>{
            const name = currentUser?.name;
            if (name) users.push({
                name: name,
                src: currentUser?.avatarUrl || ''
            });
            return users;
        }, []), [
        suggestedUsers
    ]);
    if (showSocial) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, intl.formatMessage($26ba4073e3f27460$var$i18n.publishSuccessMessageWithSocial)), avatarGroupData.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        size: "small",
        data: avatarGroupData
    }));
    const defaultMessage = spaceName ? $26ba4073e3f27460$var$i18n.publishSuccessMessageWithSpaceName : $26ba4073e3f27460$var$i18n.publishSuccessMessage;
    const messageData = {
        spaceName: spaceName,
        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, title)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, intl.formatMessage(defaultMessage, messageData)));
};


const $276e1e5cf70a16e6$export$4fb0801f02d2f353 = 11000;
const $276e1e5cf70a16e6$var$i18n = (0, $kSwu1.defineMessages)({
    publishSuccessTitle: {
        id: "editor-features.success.publish.title",
        defaultMessage: "Published!"
    },
    publishSuccessTitleWithSocial: {
        id: "editor-features.publish.success.title.with.social",
        defaultMessage: "Page successfully published"
    },
    copyLinkCTA: {
        id: "editor-features.user.copy-your-page",
        defaultMessage: "Copy link"
    },
    copiedCTA: {
        id: "editor-features.user.copied-page",
        defaultMessage: "Copied"
    },
    sharePageCTA: {
        id: "editor-features.publish.success.share-page",
        defaultMessage: "Share page"
    }
});
const $276e1e5cf70a16e6$var$copiedLinkStyles = null;
const $276e1e5cf70a16e6$export$a574f00d9ff9ab7b = async ({ spaceName: spaceName, flags: flags, title: title, intl: intl, copyContentLink: copyContentLink, createAnalyticsEvent: createAnalyticsEvent, suggestedUsers: suggestedUsers = [], showShareModal: showShareModal })=>{
    let isLinkCopied = false;
    let flagId;
    let flagTitle = $276e1e5cf70a16e6$var$i18n.publishSuccessTitleWithSocial;
    const handleCopyClick = ()=>{
        if (isLinkCopied || !copyContentLink) return;
        isLinkCopied = true;
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'publishFlagCopyPageCTA',
                source: 'publishSuccessFlag',
                attributes: {
                    isFirstTimePublish: true,
                    isSocialFlag: true
                }
            }
        }).fire();
        copyContentLink(); // Update flag with "Copied" state
        flags.updateFlag(flagId, {
            actions: createActions()
        }); // Reset after 4 seconds
        setTimeout(()=>{
            isLinkCopied = false;
            flags.updateFlag(flagId, {
                actions: createActions()
            });
        }, 4000);
    };
    const handleShareClick = ()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'publishFlagSharePageCTA',
                source: 'publishSuccessFlag',
                attributes: {
                    isFirstTimePublish: true
                }
            }
        }).fire();
        showShareModal?.();
    };
    const createActions = ()=>{
        const actions = [];
        if (copyContentLink) {
            if (!!showShareModal) actions.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $276e1e5cf70a16e6$var$i18n.sharePageCTA),
                onClick: handleShareClick
            });
            actions.push({
                content: isLinkCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_syaz1gmx"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $276e1e5cf70a16e6$var$i18n.copiedCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $276e1e5cf70a16e6$var$i18n.copyLinkCTA),
                onClick: isLinkCopied ? undefined : handleCopyClick
            });
        }
        return actions;
    }; // Create description content
    const createDescription = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26ba4073e3f27460$export$8c6a25f4516e16d9), {
            intl: intl,
            title: title,
            spaceName: spaceName,
            suggestedUsers: suggestedUsers,
            showSocial: !!copyContentLink
        });
    };
    let flagProps = {};
    if (copyContentLink) flagProps = {
        type: 'custom',
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8e565cc691ed7120$export$b06ad34367ea1e7b), null),
        description: createDescription(),
        actions: createActions()
    };
    else {
        // Fallback when no copy functions provided
        flagProps = {
            description: createDescription()
        };
        flagTitle = $276e1e5cf70a16e6$var$i18n.publishSuccessTitle;
    }
    const publishSuccessFlag = await flags.showFlag({
        type: 'success-circle',
        title: intl.formatMessage(flagTitle),
        close: 'never',
        messageId: 'confluence-frontend-editor-features-publish-success-flag',
        messageType: 'transactional',
        ...flagProps
    });
    flagId = publishSuccessFlag.id;
    setTimeout(()=>flags.hideFlag(publishSuccessFlag.id), $276e1e5cf70a16e6$export$4fb0801f02d2f353);
};






var $8aF6s = parcelRequire("8aF6s");


var $59MXn = parcelRequire("59MXn");


var $ePExc = parcelRequire("ePExc");




const $91efa2b1f405190b$export$3b8fd49302e3db30 = (contentId, spaceKey, userId)=>{
    const userIdArray = (0, $cozmU.useMemo)(()=>userId ? [
            userId
        ] : [], [
        userId
    ]);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { suggestedUsers: suggestedUsers, loading: loading } = (0, $59MXn.useUserSuggestions)({
        currentPickedPrincipalIds: userIdArray,
        maxDisplayResults: 3,
        orgId: orgId,
        siteId: cloudId
    });
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showShareModal = (0, $cozmU.useCallback)(()=>{
        showModal((0, $ePExc.ShareAndRestrictDialogController), {
            contentId: contentId,
            contentType: 'page',
            allowRestrictions: true,
            pageModes: 'view',
            refetchButtonData: ()=>{},
            isUnpublishedDraft: false,
            spaceKey: spaceKey,
            defaultSuggestedUsers: suggestedUsers || []
        });
    }, [
        showModal,
        contentId,
        spaceKey,
        suggestedUsers
    ]);
    const isEligible = (0, $cozmU.useMemo)(()=>{
        return !loading && suggestedUsers !== null && suggestedUsers.length > 0;
    }, [
        suggestedUsers,
        loading
    ]);
    const memoizedSuggestedUsers = (0, $cozmU.useMemo)(()=>{
        return suggestedUsers || [];
    }, [
        suggestedUsers
    ]);
    return {
        isEligible: isEligible,
        suggestedUsers: memoizedSuggestedUsers,
        showShareModal: showShareModal
    };
};



var $fFmJj = parcelRequire("fFmJj");


var $7tFTF = parcelRequire("7tFTF");


var $sLZsl = parcelRequire("sLZsl");




/**
 * @generated SignedSource<<8426502ce13ce29f35d10861a8c350d5>>
 * @relayHash 2d8e012bda2a33a3a3d0ebd87b80a7fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 232d266b68624c65d966ad12735bd757d7c4d6269ff83ce5e82943fe85dc3f17
const $b58df44a544029ea$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": 4,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v6 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "title"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = [
        v9 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "kind": "ScalarField",
        "name": "value"
    }, v18 = {
        "kind": "ScalarField",
        "name": "number"
    }, v19 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v20 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v19 /*: any*/ 
            ]
        }
    ], v21 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v20 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v22 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v20 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v20 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"editor\"])"
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v16 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v27 = {
        "kind": "ScalarField",
        "name": "message"
    }, v28 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v31 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v32 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v33 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "representation"
                    },
                    v17 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v8 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ 
                                ]
                            },
                            v32 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v20 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v35 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "count"
    }, v37 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v38 = {
        "kind": "ScalarField",
        "name": "background"
    }, v39 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v40 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v41 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v42 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v43 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v44 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v45 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v46 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v47 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v48 = {
        "kind": "ScalarField",
        "name": "borderRadius"
    }, v49 = {
        "kind": "ScalarField",
        "name": "padding"
    }, v50 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": [
                            v16 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "ScreenLookAndFeel",
                                "kind": "LinkedField",
                                "name": "screen",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    {
                                        "concreteType": "LayerScreenLookAndFeel",
                                        "kind": "LinkedField",
                                        "name": "layer",
                                        "plural": false,
                                        "selections": [
                                            v38 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v43 /*: any*/ ,
                                            v45 /*: any*/ ,
                                            v47 /*: any*/ ,
                                            v46 /*: any*/ ,
                                            v44 /*: any*/ ,
                                            v41 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            v40 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "width"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "height"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterTop"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterRight"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterBottom"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterLeft"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v48 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "routeOverrideEnabled"
                    }
                ]
            }
        ]
    }, v51 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v9 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentAndHeaderQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v15 /*: any*/ 
                                        }
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v15 /*: any*/ 
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v31 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v15 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentAndHeaderQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v51 /*: any*/ 
                                        }
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v51 /*: any*/ 
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v31 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v51 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "2d8e012bda2a33a3a3d0ebd87b80a7fe",
            "id": "232d266b68624c65d966ad12735bd757d7c4d6269ff83ce5e82943fe85dc3f17",
            "metadata": {},
            "name": "ContentAndHeaderQuery",
            "operationKind": "query",
            "text": "query ContentAndHeaderQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int=null,$embeddedContentRender:String=null,$limit:Int=4,$useNewContentTopper:Boolean=false){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender){nodes{id,type,subType,title,history{createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"editor\"]){nodes{id,key,value,version{number}}},space{id,key,name},version{confRev,message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},body{dynamic{representation,value,content{version{number},id},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{name,themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding},screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled}}}"
        }
    };
}();
$b58df44a544029ea$var$node.hash = "50eaca54fc132a4b9c4969be581d7332";
var $b58df44a544029ea$export$2e2bcd8739ae039 = $b58df44a544029ea$var$node;






var $bMPhU = parcelRequire("bMPhU");


var $joyRP = parcelRequire("joyRP");





var $ixL26 = parcelRequire("ixL26");

const $133247f07472b44a$export$f9375340d18f2b4b = (contentId, spaceKey)=>{
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    return (0, $cozmU.useCallback)(async ()=>{
        let spaceOverviewQueryResponse;
        let contentAndHeaderQueryResponse;
        let contentModeQueryResponse;
        if (contentId === homepageId) try {
            spaceOverviewQueryResponse = await (0, $c0rhi.queryInterop)({
                query: (0, $ixL26.default),
                context: {
                    single: true
                },
                fetchPolicy: 'network-only',
                variables: {
                    spaceKey: spaceKey,
                    excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
                },
                __callerPackage__: "@confluence/editor-features"
            });
        } catch  {
        // NOTE: We intentionally swallow any possible error here as this query is only aimed
        // populate the cache with just published content. Should any error occur here after
        // successful publishing the page, the Apollo cache for the query will be invalidated
        // anyway and View Page will fetch the page and handle possible errors.
        }
        if (contentId) {
            try {
                contentAndHeaderQueryResponse = await (0, $c0rhi.queryInterop)({
                    query: (0, $b58df44a544029ea$export$2e2bcd8739ae039),
                    context: {
                        single: true
                    },
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        useNewContentTopper: true
                    },
                    __callerPackage__: "@confluence/editor-features"
                });
            } catch  {
            // NOTE: We intentionally swallow any possible error here as this query is only aimed
            // populate the cache with just published content. Should any error occur here after
            // successful publishing the page, the Apollo cache for the query will be invalidated
            // anyway and View Page will fetch the page and handle possible errors.
            }
            try {
                contentModeQueryResponse = await (0, $c0rhi.queryInterop)({
                    query: (0, $joyRP.default),
                    context: {
                        single: true
                    },
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId,
                        isDraft: false,
                        status: [
                            'current'
                        ]
                    },
                    __callerPackage__: "@confluence/editor-features"
                });
            } catch  {
            // NOTE: Content mode query is best-effort; swallow errors to keep refetch resilient.
            }
        }
        return {
            spaceOverviewQueryResponse: spaceOverviewQueryResponse,
            contentAndHeaderQueryResponse: contentAndHeaderQueryResponse,
            contentModeQueryResponse: contentModeQueryResponse
        };
    }, [
        contentId,
        spaceKey,
        homepageId
    ]);
};



var $e9owJ = parcelRequire("e9owJ");


var $bUSKZ = parcelRequire("bUSKZ");


var $4arST = parcelRequire("4arST");








var $a2foB = parcelRequire("a2foB");


var $1ytiN = parcelRequire("1ytiN");











var $1BYn9 = parcelRequire("1BYn9");














var $letmB = parcelRequire("letmB");

const $9aa3d0667943e62d$export$db1eb611298a773e = ()=>{
    const { tenantId: tenantId } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireRequestEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'requested',
                actionSubject: 'saveHubConfirmationDialog',
                source: 'companyHub'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useCallback)(async (contentId)=>{
        if (!isProductAdmin) {
            fireRequestEvent();
            return;
        }
        const { bannerId: bannerId, bannerStatus: bannerStatus } = await (0, $letmB.getCompanyHubAnnouncementBanner)(contentId, tenantId);
        if (!bannerId) {
            fireRequestEvent();
            return;
        }
        const isBannerActive = !!bannerStatus && bannerStatus !== 'SAVED'; // 'SAVED' means archived
        if (isBannerActive) fireRequestEvent();
    }, [
        isProductAdmin,
        tenantId,
        fireRequestEvent
    ]);
};



var $k7Jwr = parcelRequire("k7Jwr");

var $5wLVq = parcelRequire("5wLVq");

const $3dd04323161a5180$var$UNAUTHORIZED_ERROR_MESSAGE = 'Current user does not have permission to update site settings';
const $3dd04323161a5180$var$i18n = (0, $kSwu1.defineMessages)({
    publishSuccessTitle: {
        id: "editor-features.success.front-cover.publish.title",
        defaultMessage: "{companyHubName} is now active"
    },
    updateSuccessTitle: {
        id: "editor-features.success.front-cover.update.title",
        defaultMessage: "{companyHubName} has been updated"
    },
    publishSuccessDescription: {
        id: "editor-features.user.publish.front-cover.success",
        defaultMessage: "This hub is now visible to everyone. Make updates to it anytime."
    },
    updateSuccessDescription: {
        id: "editor-features.user.update.front-cover.success",
        defaultMessage: "Your recent update is now visible to everyone."
    },
    publishErrorTitle: {
        id: "editor-features.front-cover.publish.error-title",
        defaultMessage: "Something went wrong"
    },
    publishErrorDescription: {
        id: "editor-features.publish.front-cover.error-message",
        defaultMessage: "Due to an error, this landing page failed to publish. Reload and publish it again."
    }
});
const $3dd04323161a5180$export$54a3ce93dad2eb8c = (spaceKey, contentId, flags, refetchNativeCollab)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { frontCoverState: frontCoverState, companyHubName: companyHubName } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const showSuccessFlag = (0, $cozmU.useCallback)(()=>{
        let title;
        let description;
        if (frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN) {
            title = $3dd04323161a5180$var$i18n.updateSuccessTitle;
            description = $3dd04323161a5180$var$i18n.updateSuccessDescription;
        } else {
            title = $3dd04323161a5180$var$i18n.publishSuccessTitle;
            description = $3dd04323161a5180$var$i18n.publishSuccessDescription;
        }
        flags?.showFlag({
            type: 'success-circle',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...title,
                values: {
                    companyHubName: companyHubName
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), description),
            close: 'never',
            // XXX Works around hideAllFlags in EditorFlags!
            customComponent: (0, $a2foB.default)
        });
    }, [
        flags,
        companyHubName,
        frontCoverState
    ]);
    const showErrorFlag = (0, $cozmU.useCallback)(()=>{
        flags?.showFlag({
            type: 'error',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dd04323161a5180$var$i18n.publishErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dd04323161a5180$var$i18n.publishErrorDescription),
            close: 'never' // XXX Works around hideAllFlags in EditorFlags!
        });
    }, [
        flags
    ]);
    const { changeHubPublishState: changeHubPublishState } = (0, $5wLVq.useChangeCompanyHubPublishState)();
    const getSuccessModalDialogData = (0, $9aa3d0667943e62d$export$db1eb611298a773e)();
    const publishCompanyHub = (0, $cozmU.useCallback)(async ()=>{
        const data = refetchNativeCollab ? await refetchNativeCollab(true) : {};
        const versionFromQuery = data?.content?.nodes?.[0]?.version?.number ?? 1;
        experienceTracker.start({
            name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE),
            attributes: {
                contentId: contentId,
                isFirstPublish: versionFromQuery === 1
            }
        });
        try {
            const { data: data } = await changeHubPublishState((0, $k7Jwr.GraphQLFrontCoverState).SHOWN);
            if (data?.updateSiteLookAndFeel?.siteLookAndFeel?.frontCoverState !== (0, $cEgMD.FrontCoverStateEnum).SHOWN) {
                const isUnauthorizedError = data?.updateSiteLookAndFeel?.errors?.some((error)=>error?.message?.includes($3dd04323161a5180$var$UNAUTHORIZED_ERROR_MESSAGE));
                if (isUnauthorizedError) {
                    experienceTracker.abort({
                        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE),
                        reason: $3dd04323161a5180$var$UNAUTHORIZED_ERROR_MESSAGE
                    });
                    return;
                } else {
                    // if extensions is needed, use mutationErrorExtensionsAggCompat from @confluence/apollo-relay-interop
                    // to convert from AGG-like response to cc-graphql-like response
                    const errors = data?.updateSiteLookAndFeel?.errors || [];
                    const errorMessages = errors.map((error)=>error.message).join('.');
                    throw new Error(errorMessages || 'An unknown error occurred');
                }
            }
            experienceTracker.succeed({
                name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
            });
        } catch (error) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE),
                error: error
            });
            throw error;
        }
    }, [
        contentId,
        experienceTracker,
        changeHubPublishState,
        refetchNativeCollab
    ]);
    const onPublishSuccess = (0, $cozmU.useCallback)(async ()=>{
        const isCompanyHubPublished = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN;
        try {
            if (!isCompanyHubPublished && isProductAdmin) await publishCompanyHub();
        } catch  {
            showErrorFlag();
            return;
        }
        await getSuccessModalDialogData(contentId);
        showSuccessFlag();
    }, [
        frontCoverState,
        isProductAdmin,
        publishCompanyHub,
        showErrorFlag,
        showSuccessFlag,
        getSuccessModalDialogData,
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return experienceTracker.subscribe((event)=>{
            if (event.name === (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE) && event.action === 'taskSuccess' && event.attributes?.isCompanyHub) onPublishSuccess();
        });
    }, [
        contentId,
        experienceTracker,
        spaceKey,
        onPublishSuccess
    ]);
};



var $duCvb = parcelRequire("duCvb");


var $3VbV8 = parcelRequire("3VbV8");


var $lREFo = parcelRequire("lREFo");


var $b4kc6 = parcelRequire("b4kc6");





var $bMmYR = parcelRequire("bMmYR");

const $0e81cbad63fd65af$export$6ff8b720f8f92483 = ({ forceRefetchContent: forceRefetchContent, maxRetryCount: maxRetryCount, retryDelayMs: retryDelayMs })=>{
    return (0, $cozmU.useCallback)(async ()=>{
        let attempts = 0;
        let isResponseInvalid = false;
        let isResponseOutdated = false;
        const forceRefetchAction = async ()=>{
            const { contentAndHeaderQueryResponse: contentAndHeaderQueryResponse } = await forceRefetchContent();
            attempts++;
            isResponseInvalid = !contentAndHeaderQueryResponse?.data?.content?.nodes?.length;
            isResponseOutdated = contentAndHeaderQueryResponse?.data?.content?.nodes?.[0]?.subType === 'live';
            // Throw an error so we retry
            if (isResponseInvalid || isResponseOutdated) throw new Error('forceRefetchPublishedLiveDoc invalid/outdated');
        };
        try {
            await (0, $bMmYR.retry)(forceRefetchAction, {
                maxAttempts: maxRetryCount,
                timeout: retryDelayMs
            });
        } catch  {
        // retry function throws an error if there are no retry attempts remaining
        }
        return {
            retryCount: attempts - 1,
            isResponseInvalid: isResponseInvalid,
            isResponseOutdated: isResponseOutdated
        };
    }, [
        forceRefetchContent,
        maxRetryCount,
        retryDelayMs
    ]);
};



var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $011b4a3eb785c077$export$95dd68d9df58d670 = ()=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>`/wiki/rest/api/content/blueprint/instance/${variables.contentId}?status=draft`,
        method: 'PUT',
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: (variables)=>{
            let history;
            if (variables.contentType === 'blogpost') history = {
                createdDate: new Date().toISOString()
            };
            const body = {
                id: variables.contentId,
                type: variables.contentType,
                title: variables.title,
                space: {
                    key: variables.spaceKey
                },
                body: {
                    atlas_doc_format: {
                        value: variables.content,
                        representation: 'atlas_doc_format',
                        content: {
                            id: variables.contentId
                        }
                    }
                },
                status: 'current',
                version: {
                    number: variables.version,
                    minorEdit: variables.suppressNotifyWatchers,
                    message: variables.message,
                    ...variables.ncsStepVersion !== undefined && {
                        ncsStepVersion: variables.ncsStepVersion
                    }
                },
                extensions: {
                    'update-trigger': 'EDIT_PAGE',
                    moveRequest: Object.keys(variables.moveRequest ?? {}).length === 0 ? undefined : variables.moveRequest
                },
                history: history,
                schedulePublishDate: variables.schedulePublishDate,
                ancestors: variables.ancestors,
                // Instead of sending restrictions: null, do not send restrictions at all
                restrictions: variables.restrictions ?? undefined
            };
            return JSON.stringify(body);
        },
        parseResponseOnSuccess: async (response)=>{
            const json = await response.json();
            return {
                status: response.status,
                traceId: response.headers.get('atl-traceid') ?? '',
                success: true,
                createdDate: json?.history?.createdDate ?? null,
                message: null,
                spaceName: json?.space?.name ?? null
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) {
                const { response: response } = error;
                let json = {};
                try {
                    json = await response.json();
                } catch  {
                // Ignore JSON parse errors
                }
                return {
                    status: response.status,
                    traceId: response.headers.get('atl-traceid') ?? '',
                    success: false,
                    createdDate: null,
                    message: json?.message ?? null,
                    spaceName: ''
                };
            }
            // Re-throw non-BadStatusError errors
            throw error;
        },
        parseResult: (parsedResponse)=>{
            return {
                experimentalPublishEditorContent: {
                    status: parsedResponse.status,
                    success: parsedResponse.success,
                    createdDate: parsedResponse.createdDate,
                    message: parsedResponse.message,
                    traceId: parsedResponse.traceId,
                    space: {
                        name: parsedResponse.spaceName
                    }
                }
            };
        }
    });
};


const $b2525498bccc76fd$var$MAX_PUBLISH_HANG_TIME = 15000;
const $b2525498bccc76fd$var$i18n = (0, $kSwu1.defineMessages)({
    titleKeywordForAutomationDiscovery: {
        id: "editor-features.title-keyword-for-automation-discovery.",
        defaultMessage: "meeting"
    },
    networkErrorTitle: {
        id: "editor-features.use-publish.network-error.title",
        defaultMessage: "Can\u2019t save changes"
    },
    networkErrorDescription: {
        id: "editor-features.use-publish.network-error.description",
        defaultMessage: "Check your network connection, refresh the page, and try again. If the problem persists, contact your administrator for help."
    },
    outdatedRefetchErrorFlagTitle: {
        id: "editor-features.use-publish.outdated-refetch-error-flag.title",
        defaultMessage: "To view your published page, refresh now"
    },
    outdatedRefetchErrorFlagDescription: {
        id: "editor-features.use-publish.outdated-refetch-error-flag.description",
        defaultMessage: "{pageTitle} was converted and published, but we weren\u2019t able to redirect to the converted page. If this keeps happening, contact Support."
    },
    outdatedRefetchFlagRefresh: {
        id: "editor-features.use-publish.outdated-refetch-error-flag.refresh",
        defaultMessage: "Refresh"
    },
    isAutoConvertedVersionMessage: {
        id: "editor-features.use-publish.is-auto-converted-version-message",
        defaultMessage: "Version published after converting to the new editor"
    }
});
class $b2525498bccc76fd$export$fe5727fc50baafc0 extends Error {
    constructor(message, traceId){
        super(message), this.message = message, this.traceId = traceId;
        this.traceId = traceId;
    }
}
const $b2525498bccc76fd$export$d55c81786220731c = ({ contentId: contentId, contentType: contentType, refetchNativeCollab: refetchNativeCollab, editorActions: editorActions, embeddedConfluenceSource: embeddedConfluenceSource, spaceKey: spaceKey, afterPublish: afterPublish, version: version, onCollabError: onCollabError, saveDraftPromise: saveDraftPromise, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish, flags: flags, dialogs: dialogs, startingLinks: startingLinks, optimisticDeleteItemInTree: optimisticDeleteItemInTree, editorPresetAPI: editorPresetAPI, handleSaveThirdPartyLinks: handleSaveThirdPartyLinks })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isPublishingContent, setIsPublishingContent] = (0, $cozmU.useState)(false);
    const { showEditorFlag: showEditorFlag } = (0, $dYcT6.useEditorFlagsContext)();
    const { showEditorModal: showEditorModal } = (0, $6LguK.useEditorModalContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, isLoggedIn: isLoggedIn, isLicensed: isLicensed, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const includeAncestors = (0, $euL71.ConfluenceEdition).FREE === edition;
    const publishMutationOptions = {
        refetchQueries: [
            {
                query: (0, $7tFTF.default),
                variables: {
                    contentId: contentId,
                    status: [
                        'current',
                        'draft',
                        'archived'
                    ],
                    includeAncestors: includeAncestors
                }
            }
        ],
        update: ()=>{
            const contentData = (0, $l1uFv.readQueryInterop)({
                query: (0, $jroIa.default),
                variables: {
                    contentId: contentId
                },
                __callerPackage__: "@confluence/editor-features"
            });
            const updatedData = JSON.parse(JSON.stringify(contentData));
            if (!updatedData || !updatedData.singleContent) return;
            const { singleContent: singleContent } = updatedData;
            const { space: space } = singleContent;
            if (contentType === 'page') singleContent.currentUserIsWatching = true;
            else if (space) {
                if (contentType === 'space') space.currentUser.isWatched = true;
                else if (contentType === 'blogpost') space.currentUser.isWatchingBlogs = true;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $jroIa.default),
                data: updatedData,
                __callerPackage__: "@confluence/editor-features"
            });
        }
    };
    const [publishPageMutation] = (0, $308Wd.useMutationInterop)((0, $81285a6b5cdfe7f0$export$2e2bcd8739ae039), {
        ...publishMutationOptions,
        __callerPackage__: "@confluence/editor-features"
    });
    const [publishBlogMutation] = (0, $308Wd.useMutationInterop)((0, $9dd255a8b6713057$export$2e2bcd8739ae039), {
        ...publishMutationOptions,
        __callerPackage__: "@confluence/editor-features"
    });
    const [experimentalPublishEditorContentBlueprintMutation] = (0, $011b4a3eb785c077$export$95dd68d9df58d670)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const forceRefetchContent = (0, $133247f07472b44a$export$f9375340d18f2b4b)(contentId, spaceKey);
    const forceRefetchPublishedLiveDoc = (0, $0e81cbad63fd65af$export$6ff8b720f8f92483)({
        forceRefetchContent: forceRefetchContent,
        maxRetryCount: 1,
        retryDelayMs: 300
    });
    const { copyContentLink: copyContentLink } = (0, $18vK6.useCopyContentLink)({
        pageMode: (0, $bPoXA.PAGE_MODE).VIEW,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: 'usePublish - publishSuccessFlag'
    });
    const migratedRecently = (0, $bUSKZ.useMigratedRecently)(contentId);
    const { setIsPublishing: setIsPublishing } = (0, $2wSyg.useDraftSyncAndPublishContext)();
    const embeddedOnPublish = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const [state, action] = (0, $kdpMy.useGeneratedTitle)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const readLabelsFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $934e7215f54d8537$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/editor-features"
    });
    const readEditorOnboardingStateFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $8e82010916e4bf31$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/editor-features"
    });
    /* Onboarding Feature */ const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, hasUserPublished: hasUserPublished, editorTutorialSuccessFlagCompleted: editorTutorialSuccessFlagCompleted } = isLoggedIn && isLicensed ? (0, $ac5cee5bdff9fad4$export$b2c224961b725273)(readEditorOnboardingStateFragment) : {
        editorOnboardingEligiblity: null,
        hasUserPublished: true,
        editorTutorialSuccessFlagCompleted: true
    };
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    // Hub editor does not support editor labels
    const isPublishingOriginalOnboardingTemplate = isLoggedIn && isLicensed && !isCompanyHub ? (0, $ac5cee5bdff9fad4$export$823364ce80d725a7)(contentId, readLabelsFragment) : false;
    const { setHasMetPublishNudgeConditions: setHasMetPublishNudgeConditions } = (0, $dz5dy.useOnboardingEditorActions)();
    const getCollabProviderState = (0, $4arST.useGetCollabProviderState)({
        editorActions: editorActions,
        collabEditProvider: collabEditProvider,
        reason: 'publish'
    });
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        embeddedConfluenceSource: embeddedConfluenceSource,
        source: 'editPageScreen',
        subject: 'page',
        version: version,
        collabService: 'ncs'
    });
    const { triggerPageConflictAnalytics: triggerPageConflictAnalytics } = (0, $gQojb.usePageConflictAnalytics)({
        source: 'usePublish',
        actionSubjectId: 'editor.publish',
        contentId: contentId,
        contentType: contentType,
        collabService: 'ncs',
        version: version
    });
    const percentDifference = (s1, s2)=>{
        const maxLength = Math.max(s1.length, s2.length);
        if (maxLength === 0) return 0;
        const distance = (0, $9pRHz.get)(s1, s2);
        return 100 - (maxLength - distance) / maxLength * 100;
    };
    (0, $3dd04323161a5180$export$54a3ce93dad2eb8c)(spaceKey, contentId, flags, refetchNativeCollab);
    const inviteOnLinkInsertEligibilityCheck = (0, $8Vmxc.useInviteOnLinkInsertEligibilityCheck)(flags);
    const showInviteOnLinkInsertFlag = (0, $8Vmxc.useShowInviteOnLinkInsertFlag)(flags);
    const { isEligible: isEligibleShareLinkSocialOnPublish, suggestedUsers: suggestedUsers, showShareModal: showShareModal } = (0, $91efa2b1f405190b$export$3b8fd49302e3db30)(contentId, spaceKey, userId);
    const handlePublish = (0, $cozmU.useCallback)(async ({ suppressNotifyWatchers: suppressNotifyWatchers, message: message, retryOnConflict: retryOnConflict, isButtonClicked: isButtonClicked, schedulePublishDate: schedulePublishDate, ancestors: ancestors, newSpaceKey: newSpaceKey, restrictions: restrictions, moveRequest: moveRequest })=>{
        // Checking condition only when button clicked (skip on retry)
        if (isButtonClicked && checkIfConditionPreventingPublish && await checkIfConditionPreventingPublish()) return;
        if (isPublishingContent) // Short circuit to prevent race conditions when multiple publishing calls are fired in rapid succession.
        return;
        // Live docs -> published page conversion utilizes this hook and we want to separate
        // conversion experience tracking from regular page publish experience tracking
        const experienceTrackingKey = isLivePage ? (0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE);
        const experienceTrackingTimeout = isLivePage ? (0, $aJPUt.ExperienceTimeout).LIVE_PAGE_PUBLISH : (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH;
        if (isButtonClicked) {
            experienceTracker.start({
                name: experienceTrackingKey,
                timeout: experienceTrackingTimeout,
                attributes: {
                    collabService: 'ncs',
                    isCompanyHub: isCompanyHub,
                    contentId: contentId
                }
            });
            (0, $3VbV8.FABRIC_PUBLISH_PAGE_METRIC).start();
        }
        // Start the publish timeout
        const publishTimeout = setTimeout(()=>{
            showEditorFlag({
                errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).PUBLISH_TIME_TOO_LONG_ERROR,
                isUnpublishedDraft: isUnpublishedDraft
            });
        }, $b2525498bccc76fd$var$MAX_PUBLISH_HANG_TIME);
        // TODO: add experience tracking and editor flag timeout
        setIsPublishingContent(true);
        if (saveDraftPromise) try {
            await saveDraftPromise;
        } catch  {
        // no-op
        }
        setIsPublishing(true);
        const data = await refetchNativeCollab(false);
        const blueprintType = (0, $lREFo.getBlueprintFromLabels)(data);
        const content = data?.content?.nodes?.[0];
        const isUnpublishedDraft = !content?.history?.createdBy;
        const versionFromQuery = content?.version?.number ?? 1;
        const currentSpaceName = content?.space?.name;
        const subType = content?.subType;
        const isSpaceOverview = content?.space?.homepageId === contentId ? true : undefined;
        const defaultErrorAttributes = {
            blueprintType: blueprintType,
            isUnpublishedDraft: isUnpublishedDraft,
            contentId: contentId,
            retryOnConflict: retryOnConflict,
            collabEditInitialized: collabEditInitialized,
            collabService: 'ncs',
            isPublishing: isPublishingContent,
            migratedRecently: migratedRecently
        };
        let isPublishLiveDocRedirectFailed = false;
        Promise.resolve(getCollabProviderState()).then((ackState)=>{
            if (!ackState) {
                experienceTracker.fail({
                    name: experienceTrackingKey,
                    error: new Error(`${experienceTrackingKey} failed: ackState is undefined`),
                    attributes: defaultErrorAttributes
                });
                return;
            }
            const { title: title, content: content, stepVersion: stepVersion } = ackState;
            const newVersionNumber = isUnpublishedDraft ? 1 : versionFromQuery + 1;
            // show onboarding modal that prompts user to enter the title when title is empty
            if (!title && editorOnboardingEligiblity && (0, $9wGTI.fg)('cc_onboarding_experience')) // only show on normal publish (do not show modal for publish without notifying watchers OR publish with version comment)
            {
                if (message === '' && !suppressNotifyWatchers) {
                    showEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL);
                    experienceTracker.abort({
                        name: experienceTrackingKey,
                        reason: `${experienceTrackingKey} aborted: title is empty on normal publish`,
                        attributes: defaultErrorAttributes
                    });
                    return;
                }
            }
            // Safety check, as title must be not empty for publish button to be enabled
            if (!title) {
                experienceTracker.abort({
                    name: experienceTrackingKey,
                    reason: `${experienceTrackingKey} aborted: title is empty`,
                    attributes: defaultErrorAttributes
                });
                showEditorFlag({
                    errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED,
                    isUnpublishedDraft: isUnpublishedDraft
                });
                return;
            }
            // Is this a newly created blueprint page
            const isBlueprintCreate = !!blueprintType && isUnpublishedDraft;
            let publishMutation;
            if (isBlueprintCreate) publishMutation = experimentalPublishEditorContentBlueprintMutation;
            else if (contentType === 'blogpost') publishMutation = publishBlogMutation;
            else publishMutation = publishPageMutation;
            const processedRestrictions = restrictions;
            // Extract new permissions fields from GqlRestrictionsInput when using the
            // persistence_specific_access_gate experiment (new explicit permissions paradigm)
            const gqlInput = (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? restrictions : undefined;
            const permissionsInput = gqlInput?.permissions ?? undefined;
            const restrictionStateInput = gqlInput?.restrictionState ?? undefined;
            // When using new permissions paradigm, don't send legacy restrictions
            const legacyRestrictions = permissionsInput || restrictionStateInput ? undefined : processedRestrictions;
            // append text to message if isAutoConverted is true informing that this version was published after converting to the new editor
            if (isAutoConverted) {
                if (message && message.trim()) message = `${message} - ${intl.formatMessage($b2525498bccc76fd$var$i18n.isAutoConvertedVersionMessage)}`;
                else message = intl.formatMessage($b2525498bccc76fd$var$i18n.isAutoConvertedVersionMessage);
            }
            return publishMutation({
                variables: {
                    contentId: contentId,
                    contentType: contentType,
                    content: JSON.stringify(content),
                    message: message,
                    spaceKey: newSpaceKey || spaceKey,
                    ncsStepVersion: stepVersion.toString(),
                    suppressNotifyWatchers: suppressNotifyWatchers,
                    title: title,
                    version: newVersionNumber,
                    schedulePublishDate: schedulePublishDate,
                    ancestors: // @ts-ignore
                    ancestors,
                    // @ts-ignore
                    restrictions: legacyRestrictions,
                    permissions: permissionsInput,
                    restrictionState: restrictionStateInput,
                    // @ts-ignore
                    moveRequest: moveRequest?.position && moveRequest?.targetId ? {
                        position: moveRequest?.position?.toUpperCase(),
                        targetId: moveRequest?.targetId
                    } : undefined,
                    isBlueprintCreate: isBlueprintCreate,
                    cloudId: cloudId
                }
            }).then(async (response)=>{
                // Retry once on a conflict when publishing
                let res;
                if (isBlueprintCreate) res = response?.data?.experimentalPublishEditorContent;
                else if (contentType === 'blogpost') res = response?.data?.confluence_updateBlogPost;
                else res = response?.data?.confluence_updatePage;
                const success = res?.success;
                let status;
                if (isBlueprintCreate) status = res?.status;
                else status = res?.errors?.[0]?.extensions?.[0]?.statusCode;
                let responseMessage;
                if (isBlueprintCreate) responseMessage = res?.message;
                else responseMessage = res?.errors?.[0]?.message;
                let traceId;
                if (isBlueprintCreate) traceId = res?.traceId;
                else traceId = response?.extensions?.gateway?.trace_id;
                let spaceName;
                if (isBlueprintCreate) spaceName = res?.space?.name ?? currentSpaceName;
                else spaceName = res?.content?.space?.name ?? currentSpaceName;
                if (status === 409 && retryOnConflict) {
                    triggerPageConflictAnalytics(responseMessage, {
                        cloudId: cloudId,
                        retry: retryOnConflict,
                        newVersionNumber: newVersionNumber,
                        migratedRecently: migratedRecently,
                        isUnpublishedDraft: isUnpublishedDraft
                    });
                    setIsPublishingContent(false);
                    handlePublish({
                        suppressNotifyWatchers: suppressNotifyWatchers,
                        message: message,
                        retryOnConflict: false,
                        isButtonClicked: false,
                        schedulePublishDate: schedulePublishDate,
                        ancestors: ancestors,
                        newSpaceKey: newSpaceKey,
                        restrictions: restrictions
                    });
                    // Short circuit so the experience doesn't get preemptively recorded as a failure.
                    // Let the retry determine what happens to the experience.
                    return;
                }
                clearTimeout(publishTimeout); // clear timeout earlier to not have false positives due to delay from after publish actions (such as fetching view content)
                if (success) {
                    (0, $3VbV8.FABRIC_PUBLISH_PAGE_METRIC).stop({
                        customData: {
                            collabService: 'ncs',
                            didRetry: !retryOnConflict
                        }
                    });
                    let flushSyncBlockSuccess = true;
                    let bodiedSuccess = true;
                    let referenceSuccess = true;
                    if (editorPresetAPI?.syncedBlock?.actions && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
                        const { flushBodiedSyncBlocks: flushBodiedSyncBlocks, flushSyncedBlocks: flushSyncedBlocks } = editorPresetAPI.syncedBlock.actions;
                        [bodiedSuccess, referenceSuccess] = await Promise.all([
                            flushBodiedSyncBlocks(),
                            flushSyncedBlocks()
                        ]);
                        flushSyncBlockSuccess = bodiedSuccess && referenceSuccess;
                    }
                    if (moveRequest?.previousParentPageId && optimisticDeleteItemInTree) optimisticDeleteItemInTree(contentId); //delete the current page so it can be moved without duplication
                    // Fire analytics Track events on publish
                    const publishAnalyticsAction = isUnpublishedDraft ? 'created' : 'updated';
                    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
                    if (state?.generatedTitle !== '') {
                        const titleDiff = percentDifference(title, state.generatedTitle);
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                actionSubject: 'editorTitle',
                                action: 'publishedAfterTitleGen',
                                source: 'editPageScreen',
                                attributes: {
                                    pageAction: publishAnalyticsAction,
                                    contentId: contentId,
                                    diffPercentage: titleDiff
                                }
                            }
                        }).fire();
                        if (titleDiff < 50) state.trackAIResultViewStored({
                            doesNotMeetMAUCriteria: false
                        });
                        action.setGeneratedTitle('');
                    }
                    // Fire analytics for title generation on paste (standard pages only)
                    if (state?.generatedTitleFromPaste !== '') {
                        state.fireResultAnalyticsFromPaste();
                        action.clearGeneratedTitleFromPaste();
                    }
                    const pageElementCounts = (0, $79LXc.getPageElementCounts)(content);
                    const numTitleWords = title.match(/\b\w+\b/g);
                    if (isEmbeddedConfluence) {
                        /*
            	When a user publishes an embedded page, a full page reload from edit -> view happens.
            	We fire the edit-page/publish experience tracker event on publish success which the EP iframe listens for in order to reload.
            	The firing of page create / page update happens asynchronously, so it can arrive much later than the experience tracker event.
            	However, for the page relaod to happen, the EP iframe only listens on the experience tracker event, and once it is recieved,
            	the edit iframe is unmounted and view iframe is mounted. During this unmount / re-mount, the track events are being lost.
            	So we await on the async call to fire the analytics, and only after that do we send the experience tracker events.
            */ try {
                            await triggerAnalyticsEvent(publishAnalyticsAction, {
                                editorType: 'next',
                                isLivePage: subType === 'live',
                                pageElementCounts: pageElementCounts,
                                titleLength: numTitleWords ? numTitleWords.length : 0
                            });
                        } catch (error) {
                            throw new Error('An error occurred while firing Track analytics events on publish:', error.message);
                        }
                        // Callback for passing page information to the parent product
                        embeddedOnPublish?.onPublish?.(spaceName, newSpaceKey);
                    } else /*
            	For Standalone Confluence, the track events fire consistently, so we don't need to await on them.
            	Also, awaiting has caused some delays with publish in the past, so we avoid it.
            	(Refer for context: https://product-fabric.atlassian.net/browse/PGXT-3858)
            */ triggerAnalyticsEvent(publishAnalyticsAction, {
                        editorType: 'next',
                        isLivePage: subType === 'live',
                        isFabric: true,
                        pageElementCounts: pageElementCounts,
                        titleLength: numTitleWords ? numTitleWords.length : 0,
                        isSpaceOverview: isSpaceOverview
                    });
                    // Dispatch experience tracker events after Track events queued to ensure firing events are in right sequence.
                    // We're intentionally not succeeding the LIVE_PAGE_PUBLISH_EXPERIENCE here as it is succeeded later in ViewPageCommon
                    // once the page conversion is successful and the user is directed to view page
                    experienceTracker.succeed({
                        name: (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE),
                        attributes: {
                            contentId: contentId,
                            collabService: 'ncs',
                            traceId: traceId,
                            newSpaceKey: newSpaceKey // SpaceKey is no longer considered UGC. This is used for CBT-3249 and will be removed when embedded confluence switches to PubSub
                        }
                    });
                    migratedRecently && experienceTracker.succeed({
                        name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
                        attributes: {
                            contentId: contentId,
                            collabService: 'ncs',
                            traceId: traceId
                        }
                    });
                    if (!schedulePublishDate && afterPublish) {
                        if (subType === 'live') {
                            // For live docs, this logic is responsible for ensuring the user gets directed from the live doc to the view page.
                            // This works because calling forceRefetchContent via forceRefetchPublishedLiveDoc has a GQL query retrieving the subType.
                            // When the now-published subType `null` is returned by GQL and stored in Apollo cache, ViewPageCommon is able to re-render as a view page.
                            // Very rarely the subType returns 'live' because GQL is outdated and doesn't see the page has been published, so
                            //   forceRefetchPublishedLiveDoc retries to give more time to get the up-to-date subtype from GQL, reducing the likelihood this issue impacts the user.
                            const { retryCount: retryCount, isResponseOutdated: isResponseOutdated, isResponseInvalid: isResponseInvalid } = await forceRefetchPublishedLiveDoc();
                            if (retryCount > 0) // We want to track when we have to retry, to keep an eye on whether this retry fix resolves the outdated subtype bug. For more details see the comment above useForceRefetchPublishedLiveDoc.
                            createAnalyticsEvent({
                                type: 'sendOperationalEvent',
                                data: {
                                    action: 'retried',
                                    actionSubject: 'forceRefetchPublishedLiveDoc',
                                    source: 'usePublish',
                                    attributes: {
                                        retryCount: retryCount,
                                        isResponseOutdated: isResponseOutdated,
                                        isResponseInvalid: isResponseInvalid,
                                        contentId: contentId
                                    }
                                }
                            }).fire();
                            if (isResponseOutdated || isResponseInvalid) {
                                // If response is still improper after forceRefetchPublishedLiveDoc retries the query, it's likely the user isn't being directed to the view page, so show a flag recommending the user refresh
                                flags?.showFlag({
                                    type: 'error',
                                    title: intl.formatMessage($b2525498bccc76fd$var$i18n.outdatedRefetchErrorFlagTitle),
                                    description: intl.formatMessage($b2525498bccc76fd$var$i18n.outdatedRefetchErrorFlagDescription, {
                                        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, title)
                                    }),
                                    close: 'never',
                                    actions: [
                                        {
                                            content: intl.formatMessage($b2525498bccc76fd$var$i18n.outdatedRefetchFlagRefresh),
                                            href: '',
                                            onClick: ()=>window.location.reload()
                                        }
                                    ]
                                });
                                isPublishLiveDocRedirectFailed = true;
                            }
                        } else await forceRefetchContent();
                        // afterPublish should be responsible for triggering a router push in order to redirect users from edit page to view page.
                        afterPublish({
                            res: res,
                            newSpaceKey: newSpaceKey,
                            isLivePagePublish: subType === 'live'
                        });
                    }
                    if (editorOnboardingEligiblity && (0, $9wGTI.fg)('cc_onboarding_experience')) {
                        if (!hasUserPublished) setOnboardingState({
                            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                            value: 'true'
                        });
                        // for the first publish, show either creator onboarding
                        setHasMetPublishNudgeConditions(!hasUserPublished);
                    }
                    if (!schedulePublishDate && flags) {
                        // when publishing the onboarding template for the first time
                        // there will be separate publish flag shown through EditorPublishSuccessFlag
                        const shouldShowTutorialSuccessFlag = isPublishingOriginalOnboardingTemplate && !editorTutorialSuccessFlagCompleted;
                        const isValidAutomationDiscoveryUseCase = ((0, $9wGTI.fg)('a4c_free_and_standard_editions') || edition === (0, $euL71.ConfluenceEdition).PREMIUM) && contentType === 'page' && isUnpublishedDraft;
                        const eligibleForJiraLinkAutomationDiscoveryDialog = isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_JIRA_LINK) && (0, $0717d343d1ada114$export$246914ca6c1b255a)(content);
                        const eligibleForMeetingNotesAutomationDiscoveryDialog = isAdminHubAIEnabled && isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE) && title.toLowerCase().includes(intl.formatMessage($b2525498bccc76fd$var$i18n.titleKeywordForAutomationDiscovery));
                        const shouldDisplayWhiteboardDiscoveryDialog = isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_WHITE_BOARDS) && (0, $5ueVa.isEligibleForWhiteboardDiscovery)(title);
                        const shouldDisplayReleaseNotesDiscoveryDialog = isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_RELEASE_NOTES) && (0, $f4L8J.isEligibleForReleaseNotesDiscovery)(title, intl) && (0, $9wGTI.fg)('a4c_rovo_release_notes_prompt');
                        const shouldDisplayProductRequirementsDiscoveryDialog = isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS) && (0, $9wXqm.isEligibleForProductRequirementsDiscovery)(title, intl) && (0, $9wGTI.fg)('a4c_rovo_contextual_prompts');
                        const shouldDisplayFeedbackAnalysisDiscoveryDialog = isValidAutomationDiscoveryUseCase && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS) && (0, $ekkfU.isEligibleForFeedbackAnalysisDiscovery)(title, intl) && (0, $9wGTI.fg)('a4c_rovo_feedback_analysis_prompt');
                        const showModalProps = {
                            publishedPageTitle: title,
                            spaceName: spaceName,
                            spaceKey: spaceKey
                        };
                        /**
             * Replace the publish success flag w/ an automation dialog if:
             * 1. It's a premium instance
             * 2. The FF is enabled
             * 3. The newly published page has the word "meeting" in it
             * 4. Must be a page
             * 5. User has not dismissed the dialog before (tracked in localStorage)
             */ /*
             * If a Jira link is pasted AND the title has "meeting" in it, this triggers both automation dialogs.
             * In that case, we will show the Jira link dialog and not the meeting notes dialog.
             * Once the user dismisses/proceeds with the Jira link dialog, we will show the meeting notes dialog on next trigger.
             */ if (shouldDisplayWhiteboardDiscoveryDialog) dialogs?.showModal((0, $e4ac836f115646bd$export$abca55d634d2e553), showModalProps);
                        else if (shouldDisplayProductRequirementsDiscoveryDialog) dialogs?.showModal((0, $92551eab53850ddc$export$bbd0e35c0a1b0e83), showModalProps);
                        else if (eligibleForJiraLinkAutomationDiscoveryDialog) {
                            experienceTracker.start({
                                name: (0, $irVI7.AUTOMATION_DISCOVERY_JIRA_LINK)
                            });
                            dialogs?.showModal((0, $e46dcb986a461856$export$8b23712115c25226), showModalProps);
                        } else if (shouldDisplayReleaseNotesDiscoveryDialog) dialogs?.showModal((0, $28e13e40d3bc36a0$export$10eabf8fa127a1ac), showModalProps);
                        else if (shouldDisplayFeedbackAnalysisDiscoveryDialog) dialogs?.showModal((0, $26b5830c490d8616$export$2b5a9d8588be205e), showModalProps);
                        else if (eligibleForMeetingNotesAutomationDiscoveryDialog) {
                            experienceTracker.start({
                                name: (0, $irVI7.AUTOMATION_DISCOVERY_PUBLISH_MEETING_NOTES_EXPERIENCE)
                            });
                            dialogs?.showModal((0, $5ce33797797432c2$export$e2477c5ccf2a6633), showModalProps);
                        } else {
                            if (editorOnboardingEligiblity && // conditions to hide the publish success flags
                            (shouldShowTutorialSuccessFlag || // first publish should show EditorPublishSuccessFlag instead
                            !hasUserPublished) && (0, $9wGTI.fg)('cc_onboarding_experience')) return;
                            // Publishing in the Company Hub involves more steps so the
                            // success flag in that case comes later. These are
                            // implemented in usePublishCompanyHub hook.
                            // If we already showed the refetch error flag (isPublishLiveDocRedirectFailed=true), don't show this flag as it would confuse the user to see both.
                            if (!isCompanyHub && !isPublishLiveDocRedirectFailed) {
                                const isFirstTimePublish = isUnpublishedDraft || subType === 'live';
                                const isConvertingFromLivePage = subType === 'live' && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in');
                                const canShowPublishSuccessWithSocialAndCopyLink = isEligibleShareLinkSocialOnPublish && isFirstTimePublish && !isConvertingFromLivePage;
                                if (canShowPublishSuccessWithSocialAndCopyLink) (0, $276e1e5cf70a16e6$export$a574f00d9ff9ab7b)({
                                    spaceName: spaceName,
                                    flags: flags,
                                    title: title,
                                    intl: intl,
                                    copyContentLink: copyContentLink,
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    suggestedUsers: suggestedUsers,
                                    showShareModal: showShareModal
                                });
                                else (0, $duCvb.showPublishSuccessFlags)({
                                    isFirstTimePublish: isFirstTimePublish,
                                    spaceName: spaceName,
                                    flags: flags,
                                    title: title,
                                    intl: intl,
                                    copyContentLink: copyContentLink,
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    isConvertingFromLivePage: isConvertingFromLivePage
                                });
                            }
                            // show sync block syncing failed error flag after the publish success flag as publishing was not blocked
                            if (!flushSyncBlockSuccess && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
                                const { flushBodiedSyncBlocks: flushBodiedSyncBlocks, flushSyncedBlocks: flushSyncedBlocks } = editorPresetAPI?.syncedBlock?.actions ?? {};
                                const retryFlush = async ()=>{
                                    const [retryBodied, retryReference] = await Promise.all([
                                        bodiedSuccess ? Promise.resolve(true) : flushBodiedSyncBlocks?.() ?? Promise.resolve(true),
                                        referenceSuccess ? Promise.resolve(true) : flushSyncedBlocks?.() ?? Promise.resolve(true)
                                    ]);
                                    return retryBodied && retryReference;
                                };
                                setTimeout(()=>{
                                    (0, $b4kc6.showFlushSyncBlockErrorFlag)(flags, intl, retryFlush);
                                }, 1000);
                            }
                            if (!isLivePage) handleSaveThirdPartyLinks?.(content);
                            inviteOnLinkInsertEligibilityCheck(contentId, content, newVersionNumber, startingLinks).then((result)=>{
                                if (result) showInviteOnLinkInsertFlag(result);
                            }).catch(()=>{
                            // no-op
                            });
                        }
                    }
                } else {
                    showEditorFlag({
                        errorName: responseMessage ?? '',
                        statusCode: status ?? undefined,
                        collabService: 'ncs',
                        isUnpublishedDraft: isUnpublishedDraft
                    });
                    // prettier-ignore
                    if (status === 400 && responseMessage?.includes("A page with this title already exists")) // Don't fail experience for bad user input, e.g. duplicate title.
                    // Confluence can throw BadRequestException 400 in other cases that may mean a code regression, although others may also be caused by bad user input
                    experienceTracker.abort({
                        name: experienceTrackingKey,
                        reason: `${experienceTrackingKey} aborted: title is a duplicate`,
                        attributes: {
                            ...defaultErrorAttributes,
                            reason: responseMessage,
                            traceId: traceId
                        }
                    });
                    else if (status === 409 && (responseMessage?.includes("optimistic locking failed") || responseMessage?.includes("Version must be incremented on update"))) // these errors are caused by user behaviour, e.g. simultaneous publishes by different users, or for HibernateOptimisticLockingFailureException ConflictException external updates to the content at the same time (e.g. comments, link refactoring)
                    // therefore, we don't consider as a failure
                    experienceTracker.abort({
                        name: experienceTrackingKey,
                        reason: `${experienceTrackingKey} aborted: content updated concurrently`,
                        attributes: {
                            ...defaultErrorAttributes,
                            reason: responseMessage,
                            traceId: traceId
                        }
                    });
                    else if (status && status >= 400 && status <= 499) experienceTracker.abort({
                        name: experienceTrackingKey,
                        reason: `${experienceTrackingKey} aborted: User error with status code ${status}`,
                        attributes: {
                            ...defaultErrorAttributes,
                            traceId: traceId,
                            reason: responseMessage
                        }
                    });
                    else if (status && status >= 500) experienceTracker.fail({
                        name: experienceTrackingKey,
                        error: new $b2525498bccc76fd$export$fe5727fc50baafc0(`${experienceTrackingKey} failed: Error with status code ${status}`, traceId),
                        attributes: {
                            ...defaultErrorAttributes,
                            traceId: traceId,
                            reason: responseMessage
                        }
                    });
                    else // If the status code is not between 400 and 599, we consider it a client network failure
                    experienceTracker.abort({
                        name: experienceTrackingKey,
                        reason: `${experienceTrackingKey} aborted: Presumed client network failure with status code ${status}`,
                        attributes: {
                            ...defaultErrorAttributes,
                            reason: responseMessage
                        }
                    });
                    migratedRecently && experienceTracker.fail({
                        name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
                        error: new Error(`${(0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE)} failed: Error with status code ${status}`),
                        attributes: {
                            ...defaultErrorAttributes,
                            traceId: traceId
                        }
                    });
                }
            });
        }).catch((err)=>{
            const experienceError = err || new Error('unknown error while publishing content');
            // copied from packages/confluence-fabric-editor/src/components/ContentEditorBindings/ContentEditorBindingsComponent.tsx
            const errorAttributes = {
                ...defaultErrorAttributes,
                stack: experienceError.stack
            };
            if (err?.message == 'Called getResolvedEditorState before editorView is ready') // editor has been unmounted, likely navigation during publish
            experienceTracker.abort({
                name: experienceTrackingKey,
                reason: `${experienceTrackingKey} aborted: Called getResolvedEditorState before editorView is ready`,
                attributes: defaultErrorAttributes
            });
            else if ((0, $6fil2.containsNetworkError)(err) || err?.message === 'GraphQL error: Failed to fetch') {
                flags?.showErrorFlag({
                    id: 'publish-network-error-flag',
                    title: intl.formatMessage($b2525498bccc76fd$var$i18n.networkErrorTitle),
                    description: intl.formatMessage($b2525498bccc76fd$var$i18n.networkErrorDescription)
                });
                experienceTracker.abort({
                    name: experienceTrackingKey,
                    reason: `${experienceTrackingKey} aborted: Client network failure`,
                    attributes: defaultErrorAttributes
                });
            } else {
                onCollabError();
                (0, $fGzMp.stopExperienceOnError)(experienceTrackingKey, experienceError, errorAttributes);
            }
            migratedRecently && (0, $fGzMp.stopExperienceOnError)((0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE), experienceError, errorAttributes);
        }).finally(()=>{
            clearTimeout(publishTimeout);
            (0, $3VbV8.FABRIC_PUBLISH_PAGE_METRIC).cancel(); // cancel BM3 event for errors as errors may skew performance SLO
            // If user's live doc failed to redirect them on publish, don't set isPublishing to false because that will re-enable the editor
            if (!isPublishLiveDocRedirectFailed) {
                setIsPublishing(false);
                setIsPublishingContent(false);
            }
        });
    }, [
        editorPresetAPI?.syncedBlock?.actions,
        checkIfConditionPreventingPublish,
        saveDraftPromise,
        setIsPublishing,
        refetchNativeCollab,
        contentId,
        collabEditInitialized,
        isPublishingContent,
        migratedRecently,
        getCollabProviderState,
        experienceTracker,
        isCompanyHub,
        showEditorFlag,
        editorOnboardingEligiblity,
        experimentalPublishEditorContentBlueprintMutation,
        contentType,
        spaceKey,
        showEditorModal,
        triggerPageConflictAnalytics,
        cloudId,
        afterPublish,
        flags,
        embeddedOnPublish,
        triggerAnalyticsEvent,
        createAnalyticsEvent,
        forceRefetchContent,
        forceRefetchPublishedLiveDoc,
        hasUserPublished,
        setHasMetPublishNudgeConditions,
        setOnboardingState,
        isPublishingOriginalOnboardingTemplate,
        editorTutorialSuccessFlagCompleted,
        edition,
        isAdminHubAIEnabled,
        intl,
        dialogs,
        inviteOnLinkInsertEligibilityCheck,
        showInviteOnLinkInsertFlag,
        startingLinks,
        copyContentLink,
        onCollabError,
        action,
        state,
        isLivePage,
        optimisticDeleteItemInTree,
        isEligibleShareLinkSocialOnPublish,
        showShareModal,
        suggestedUsers,
        publishPageMutation,
        publishBlogMutation,
        isAutoConverted,
        handleSaveThirdPartyLinks
    ]);
    const onPublish = (0, $cozmU.useCallback)(({ suppressNotifyWatchers: suppressNotifyWatchers = false, message: message = '', schedulePublishDate: schedulePublishDate = null, ancestors: ancestors = [], restrictions: restrictions, retryOnConflict: retryOnConflict = true, newSpaceKey: newSpaceKey, moveRequest: moveRequest })=>{
        return ()=>handlePublish({
                suppressNotifyWatchers: suppressNotifyWatchers,
                message: message,
                retryOnConflict: retryOnConflict,
                isButtonClicked: true,
                schedulePublishDate: schedulePublishDate,
                ancestors: ancestors,
                restrictions: restrictions,
                newSpaceKey: newSpaceKey,
                moveRequest: moveRequest
            });
    }, [
        handlePublish
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onPublish: onPublish,
            isPublishingContent: isPublishingContent
        }), [
        isPublishingContent,
        onPublish
    ]);
};



var $6080dfe70681987a$export$c5c68a3d26246634 = /*#__PURE__*/ function(ContentTypeType) {
    ContentTypeType["PAGE"] = "page";
    ContentTypeType["BLOGPOST"] = "blogpost";
    return ContentTypeType;
}({});
const $6080dfe70681987a$export$efa8e7a0a320660a = ({ contentId: contentId, contentType: contentType, refetchNativeCollab: refetchNativeCollab, editorActions: editorActions, embeddedConfluenceSource: embeddedConfluenceSource, isFirstParticipant: isFirstParticipant, isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, title: title, version: version, onCollabError: onCollabError, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish, flags: flags, dialogs: dialogs, editorPresetAPI: editorPresetAPI, editorSessionId: editorSessionId, onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree, optimisticDeleteItemInTree: optimisticDeleteItemInTree, startingLinks: startingLinks, handleSaveThirdPartyLinks: handleSaveThirdPartyLinks, viewMode: viewMode, sendNativeEmbedChildCommand: sendNativeEmbedChildCommand })=>{
    const _isSavingDraft = (0, $cozmU.useRef)(false);
    const { push: push, match: match, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const forceRefetchContent = (0, $133247f07472b44a$export$f9375340d18f2b4b)(contentId, spaceKey);
    const pushWithRoutePolicy = (0, $cozmU.useCallback)((url)=>{
        const targetUrl = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $1NBp8.COMPANY_HUB).toUrl() : url;
        const route = matchRoute(targetUrl);
        if (routePolicy && !routePolicy.willPushInSelf(match?.name, contentId, route?.name, route?.params?.contentId)) return;
        push(targetUrl);
    }, [
        matchRoute,
        routePolicy,
        contentId,
        match,
        push,
        spaceKey
    ]);
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    // Phase 2: Capture native embed state at mount time, before the SPA router
    // can strip the bridge query params (nativeEmbedChildId / nativeEmbedParentId)
    // from window.location.search during internal navigations.
    // Phase 1 (cc-maui-experiment) re-checked on every call; phase 2 captures once.
    const isNativeEmbedRef = (0, $cozmU.useRef)(!!(0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search)) && ((0, $6mKj3.expVal)('cc-maui-experiment', 'isEnabled', false) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')));
    const isNativeEmbed = ()=>{
        return !!(0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search)) && ((0, $6mKj3.expVal)('cc-maui-experiment', 'isEnabled', false) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience'));
    };
    const navigateOrSignalSwitchToViewing = (0, $cozmU.useCallback)((url)=>{
        const nativeEmbedDetected = (0, $9wGTI.fg)('cc-maui-phase-2') || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience') ? isNativeEmbedRef.current : isNativeEmbed();
        if (nativeEmbedDetected && sendNativeEmbedChildCommand) sendNativeEmbedChildCommand({
            type: 'switch-to-viewing'
        });
        else pushWithRoutePolicy(url);
    }, [
        sendNativeEmbedChildCommand,
        pushWithRoutePolicy
    ]);
    const navigateOnClose = (0, $cozmU.useCallback)(async (args)=>{
        // Refetch content to resolve stale cache issues
        await forceRefetchContent();
        // The `isDiscarding` check here prevents a race condition with the page tree refresh code
        // triggered when discarding a blank draft (in EditorPrimaryToolbarComponent.tsx).
        if (isUnpublishedDraft && !args?.isDiscarding) onPublishUpdateTitleInPageTree?.();
        const url = (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
        navigateOrSignalSwitchToViewing(url);
    }, [
        isUnpublishedDraft,
        contentType,
        breadcrumbs,
        spaceKey,
        contentId,
        forceRefetchContent,
        navigateOrSignalSwitchToViewing,
        onPublishUpdateTitleInPageTree
    ]);
    const navigateOnPublish = (0, $cozmU.useCallback)(({ res: res, newSpaceKey: newSpaceKey, isLivePagePublish: isLivePagePublish })=>{
        let url = (0, $cb6fO.buildContentPath)(newSpaceKey || spaceKey, contentId, contentType, res.createdDate, (0, $cb6fO.generateSlug)(title));
        // SSR rendered live pages that are published must be treated as a transition manually like this. If we don't, ViewPageCommon may erronously assume the just-published page is still a live doc and render it incorrectly as LivePageComponent
        if (window.__SSR_RENDERED__ && isLivePagePublish) url = (0, $cb6fO.addQueryParams)(url, {
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
        (0, $lABjq.pagePublishedState).pageJustPublished = true;
        navigateOrSignalSwitchToViewing(url);
    }, [
        spaceKey,
        contentId,
        contentType,
        title,
        navigateOrSignalSwitchToViewing
    ]);
    // Draft Sync Handling
    const { triggerSaveDraft: triggerSaveDraft, isSavingDraft: isSavingDraft, saveDraft: saveDraft, saveDraftPromise: saveDraftPromise, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, saveDraftError: saveDraftError } = (0, $9F9dn.useDraftSync)({
        contentId: contentId,
        editorActions: editorActions,
        contentType: contentType,
        isFirstParticipant: isFirstParticipant,
        onCollabError: onCollabError,
        editorPresetAPI: editorPresetAPI,
        editorSessionId: editorSessionId,
        viewMode: viewMode
    });
    (0, $cozmU.useEffect)(()=>{
        _isSavingDraft.current = isSavingDraft;
    }, [
        isSavingDraft
    ]);
    const afterPublish = (0, $cozmU.useCallback)(({ res: res, newSpaceKey: newSpaceKey, isLivePagePublish: isLivePagePublish })=>{
        cancelDebouncedSaveDraft();
        onPublishUpdateTitleInPageTree?.();
        navigateOnPublish({
            res: res,
            newSpaceKey: newSpaceKey,
            isLivePagePublish: isLivePagePublish
        });
    }, [
        cancelDebouncedSaveDraft,
        onPublishUpdateTitleInPageTree,
        navigateOnPublish
    ]);
    // Publish Handling
    const { isPublishingContent: isPublishingContent, onPublish: onPublish } = (0, $b2525498bccc76fd$export$d55c81786220731c)({
        contentId: contentId,
        contentType: contentType,
        embeddedConfluenceSource: embeddedConfluenceSource,
        refetchNativeCollab: refetchNativeCollab,
        editorActions: editorActions,
        spaceKey: spaceKey,
        afterPublish: afterPublish,
        version: version,
        onCollabError: onCollabError,
        saveDraftPromise: saveDraftPromise,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        dialogs: dialogs,
        startingLinks: startingLinks,
        optimisticDeleteItemInTree: optimisticDeleteItemInTree,
        editorPresetAPI: editorPresetAPI,
        handleSaveThirdPartyLinks: handleSaveThirdPartyLinks
    });
    return (0, $cozmU.useMemo)(()=>({
            triggerSaveDraft: triggerSaveDraft,
            isSavingDraft: isSavingDraft,
            saveDraftError: saveDraftError,
            isPublishingContent: isPublishingContent,
            cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
            onPublish: onPublish,
            navigateOnClose: navigateOnClose,
            saveDraft: saveDraft
        }), [
        triggerSaveDraft,
        isSavingDraft,
        saveDraftError,
        isPublishingContent,
        cancelDebouncedSaveDraft,
        onPublish,
        navigateOnClose,
        saveDraft
    ]);
};
module.exports["ContentTypeType"] = $6080dfe70681987a$export$c5c68a3d26246634;
module.exports["useDraftSyncAndPublish"] = $6080dfe70681987a$export$efa8e7a0a320660a;

});

parcelRegister("9F9dn", function(module, exports) {
/**
 * @generated SignedSource<<e79642ac5229202497cb2faa7ae8eb0b>>
 * @relayHash b72d5285d7750d849089af91967dd685
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e01360339416305ce958280bcb677844f30b9ecb59d2f476a43439459bd31db
const $3919374c368218f0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpdateRelationPayload",
            "kind": "LinkedField",
            "name": "updateRelation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "targetKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "sourceKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "relationName"
                },
                {
                    "kind": "ScalarField",
                    "name": "url"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDraftSyncSetRelationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDraftSyncSetRelationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b72d5285d7750d849089af91967dd685",
            "id": "4e01360339416305ce958280bcb677844f30b9ecb59d2f476a43439459bd31db",
            "metadata": {},
            "name": "useDraftSyncSetRelationMutation",
            "operationKind": "mutation",
            "text": "mutation useDraftSyncSetRelationMutation($input:UpdateRelationInput!){updateRelation(input:$input){targetKey,sourceKey,relationName,url}}"
        }
    };
}();
$3919374c368218f0$var$node.hash = "2f841a75be5c10aa568f6dcd9e89a16d";
var $3919374c368218f0$export$2e2bcd8739ae039 = $3919374c368218f0$var$node;



var $55fM8 = parcelRequire("55fM8");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $422HI = parcelRequire("422HI");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");





var $f9jv7 = parcelRequire("f9jv7");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $hYoU4 = parcelRequire("hYoU4");


var $2wSyg = parcelRequire("2wSyg");


var $hBkCm = parcelRequire("hBkCm");


var $7QM6o = parcelRequire("7QM6o");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $1xpoY = parcelRequire("1xpoY");


var $308Wd = parcelRequire("308Wd");


var $4arST = parcelRequire("4arST");

/**
 * @generated SignedSource<<adf48d4ea724ef97784c13708ed0f375>>
 * @relayHash 0507c25737fc28aed3ec38fd944fa860
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ae1dbf38b936a9ae4f0dd143906b7cf22c21e52f08c056bfbda1bdf5a4e3cc9
const $e7616b3538d8a5bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft"
                    ]
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ncsStepVersion"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSkipDraftSyncSkipDraftContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSkipDraftSyncSkipDraftContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0507c25737fc28aed3ec38fd944fa860",
            "id": "1ae1dbf38b936a9ae4f0dd143906b7cf22c21e52f08c056bfbda1bdf5a4e3cc9",
            "metadata": {},
            "name": "useSkipDraftSyncSkipDraftContentQuery",
            "operationKind": "query",
            "text": "query useSkipDraftSyncSkipDraftContentQuery($contentId:ID!){singleContent(id:$contentId,status:[\"draft\"]){id,title,version{ncsStepVersion}}}"
        }
    };
}();
$e7616b3538d8a5bb$var$node.hash = "d443b97bc4e41097cd60a592da561b7b";
var $e7616b3538d8a5bb$export$2e2bcd8739ae039 = $e7616b3538d8a5bb$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $1a4d7fbb4c80dd55$export$39f56a57fd8a0a16 = ({ contentId: contentId })=>{
    const originalStepVersion = (0, $cozmU.useRef)(undefined);
    const originalTitle = (0, $cozmU.useRef)(undefined);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $e7616b3538d8a5bb$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/editor-features"
    });
    (0, $cozmU.useEffect)(()=>{
        const stepVersion = data?.singleContent?.version?.ncsStepVersion;
        originalStepVersion.current = stepVersion ? parseInt(stepVersion) : undefined;
        originalTitle.current = data?.singleContent?.title ?? undefined;
    }, [
        data
    ]);
    /**
   * Returns true if either the latest NCS step version or title differ from
   * the version/title of the published content.
   * @param currentStepVersion the step version from the resolved editor state
   * @param currentTitle the title from the resolved editor state
   */ const isEditorDirty = (0, $cozmU.useCallback)((currentStepVersion, currentTitle)=>{
        if (!originalStepVersion.current || !originalTitle.current) return true;
        const stepVersionDiffers = currentStepVersion !== originalStepVersion.current;
        const titleDiffers = currentTitle !== originalTitle.current;
        return stepVersionDiffers || titleDiffers;
    }, []);
    return {
        isEditorDirty: isEditorDirty
    };
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $303e1416b28a8ed8$export$43e683e1574d54 = /*#__PURE__*/ function(RelationSourceType) {
    RelationSourceType["user"] = "user";
    return RelationSourceType;
}({});
var $303e1416b28a8ed8$export$298b6537334b9281 = /*#__PURE__*/ function(RelationTargetType) {
    RelationTargetType["content"] = "content";
    RelationTargetType["space"] = "space";
    return RelationTargetType;
}({});
var $303e1416b28a8ed8$export$ebeccdce1e2968d0 = /*#__PURE__*/ function(RelationType) {
    RelationType["collaborator"] = "collaborator";
    RelationType["favourite"] = "favourite";
    RelationType["touched"] = "touched";
    return RelationType;
}({});



var $16o3K = parcelRequire("16o3K");


var $lEnke = parcelRequire("lEnke");

const $a885b97ec949673f$var$useDraftSyncSetRelationMutation = (0, $3919374c368218f0$export$2e2bcd8739ae039);
const $a885b97ec949673f$var$DRAFT_SYNC_TIMEOUT = 5000;
var $a885b97ec949673f$export$ffca9a2021d0de48 = /*#__PURE__*/ function(DRAFT_SYNC_ERROR) {
    DRAFT_SYNC_ERROR["COLLAB_PROVIDER"] = "DRAFT_SYNC_ERROR_COLLAB_PROVIDER";
    DRAFT_SYNC_ERROR["ACK_STATE"] = "DRAFT_SYNC_ERROR_ACK_STATE";
    DRAFT_SYNC_ERROR["NO_ACCESS"] = "DRAFT_SYNC_ERROR_NO_ACCESS";
    return DRAFT_SYNC_ERROR;
}({});
class $a885b97ec949673f$export$bae3ecc5df674a2 {
    constructor(reason){
        this.reason = reason;
        this.reason = reason;
    }
}
class $a885b97ec949673f$export$f4897c33bb31b742 extends Error {
    constructor(message, statusCode){
        super(message), this.message = message, this.statusCode = statusCode;
        this.statusCode = statusCode;
    }
}
const $a885b97ec949673f$var$DRAFT_SYNC_EXCLUDED_STEPS = [
    'override-document',
    'atlaskit-analytics'
];
const $a885b97ec949673f$export$772c75ad2e0d1281 = ({ contentId: contentId, contentType: contentType, editorActions: editorActions, isFirstParticipant: isFirstParticipant, onCollabError: onCollabError, editorPresetAPI: editorPresetAPI, editorSessionId: editorSessionId, viewMode: viewMode })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const draftSyncDebounceMaxWait = (0, $1xpoY.default).getNumber('draft_sync_debounce_max_wait', 0);
    const { hasEditorContentChangedByAnyUser: hasEditorContentChangedByAnyUser, hasEditorContentChangedByLocalUserExcludingComments: hasEditorContentChangedByLocalUserExcludingComments } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorPresetAPI
    });
    const [isSaving, setIsSaving] = (0, $cozmU.useState)(false);
    const [draftSyncError, setDraftSyncError] = (0, $cozmU.useState)(null);
    const saveDraftPromiseRef = (0, $cozmU.useRef)(null);
    const didUnmount = (0, $cozmU.useRef)(false);
    const [experimentalDraftSyncMutation] = (0, $lEnke.useExperimentalDraftSyncMutation)();
    const [setRelationMutation] = (0, $308Wd.useMutationInterop)($a885b97ec949673f$var$useDraftSyncSetRelationMutation, {
        __callerPackage__: "@confluence/editor-features"
    });
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }, { setIsDraftSyncPending: setIsDraftSyncPending }] = (0, $hYoU4.useNativeCollabState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getIsPublishing: getIsPublishing } = (0, $2wSyg.useDraftSyncAndPublishContext)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)(); // Live pages use draft sync v2 via useEditorDraftSyncAction instead of this hook
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const getCollabProviderState = (0, $4arST.useGetCollabProviderState)({
        editorActions: editorActions,
        collabEditProvider: collabEditProvider,
        forceAwaitCommitLocalSteps: true,
        // using getResolvedEditorState ensures any active media uploads are completed, and that we sync the "confirmed" version from NCS backend
        reason: 'draft-sync'
    });
    const { isEditorDirty: isEditorDirty } = (0, $1a4d7fbb4c80dd55$export$39f56a57fd8a0a16)({
        contentId: contentId
    });
    const setRelation = (0, $cozmU.useCallback)(async (relationType)=>{
        try {
            await setRelationMutation({
                variables: {
                    input: {
                        relationName: relationType,
                        sourceKey: 'current',
                        sourceType: (0, $303e1416b28a8ed8$export$43e683e1574d54).user,
                        targetType: (0, $303e1416b28a8ed8$export$298b6537334b9281).content,
                        targetKey: contentId,
                        targetStatus: 'draft'
                    }
                }
            });
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        }
    }, [
        contentId,
        setRelationMutation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            didUnmount.current = true;
        };
    }, []);
    const hasTriggeredContentChange = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasEditorContentChangedByLocalUserExcludingComments || !window || hasTriggeredContentChange.current) return;
        const later = window.requestIdleCallback || window.requestAnimationFrame;
        hasTriggeredContentChange.current = true;
        later(async ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'nativeCollabComponent',
                    action: 'edited',
                    actionSubject: 'editor',
                    containerType: 'space',
                    containerId: spaceId,
                    objectType: 'page',
                    objectId: contentId,
                    attributes: {
                        isLivePage: isLivePage,
                        editorSessionId: editorSessionId
                    }
                }
            }).fire();
            // For Draft Sync V2, relations are set on the backend
            if (isLivePage) return;
            else setRelation((0, $303e1416b28a8ed8$export$ebeccdce1e2968d0).touched);
        });
    }, [
        contentId,
        isLivePage,
        editorSessionId,
        createAnalyticsEvent,
        hasEditorContentChangedByLocalUserExcludingComments,
        viewMode,
        setRelation,
        spaceId
    ]);
    const saveDraft = (0, $cozmU.useCallback)((awaitCommitLocalSteps = false)=>{
        /**
     * The draft sync should be skipped if:
     * - The current user is not the first participant
     * - The page is currently being published
     * - Collab edit is not initialized
     * - The hook has unmounted (the user has navigated away from the editor)
     */ if (!isFirstParticipant || getIsPublishing() || !collabEditInitialized || didUnmount.current || isLivePage) {
            setIsDraftSyncPending(false);
            return Promise.resolve();
        }
        if (saveDraftPromiseRef.current != null) return saveDraftPromiseRef.current;
        setIsSaving(true);
        saveDraftPromiseRef.current = new Promise(async (resolve, reject)=>{
            if (!collabEditProvider) return reject(new $a885b97ec949673f$export$bae3ecc5df674a2("DRAFT_SYNC_ERROR_COLLAB_PROVIDER"));
            if (draftSyncError) // We don't want to continue saving the draft in the background
            return reject(new $a885b97ec949673f$export$bae3ecc5df674a2("DRAFT_SYNC_ERROR_NO_ACCESS"));
            let ackState;
            try {
                ackState = await getCollabProviderState(awaitCommitLocalSteps);
                if (!ackState) return reject(new $a885b97ec949673f$export$bae3ecc5df674a2("DRAFT_SYNC_ERROR_ACK_STATE"));
            } catch (err) {
                onCollabError();
                reject(err);
            }
            const { title: title, content: content, stepVersion: stepVersion } = ackState;
            if (!isEditorDirty(stepVersion, title)) return resolve();
            try {
                await experimentalDraftSyncMutation({
                    variables: {
                        contentId: contentId,
                        contentType: contentType,
                        content: JSON.stringify(content),
                        ncsStepVersion: stepVersion.toString(),
                        title: title
                    }
                });
                resolve();
            } catch (e) {
                // If there's a 403 or 404 from saving the draft it's most likely because the permissions have changed, so we should disable the editor and show a flag (CONFCLOUD-66357)
                if ((0, $1uFM6.isUnauthorizedError)(e)) setDraftSyncError(new $a885b97ec949673f$export$f4897c33bb31b742(e.message, 403));
                else if ((0, $f9jv7.isNotFoundError)(e)) setDraftSyncError(new $a885b97ec949673f$export$f4897c33bb31b742(e.message, 404));
                else if ((0, $aMcHK.isStatusCodeError)(e, '503') && e?.message?.includes('Site temporarily unavailable')) setDraftSyncError(new $a885b97ec949673f$export$f4897c33bb31b742(e.message, 503));
                else if ((0, $aMcHK.isStatusCodeError)(e, '413')) // If there's a 413 from saving the draft, the page content is too large. Show a flag
                // to inform the user.
                setDraftSyncError(new $a885b97ec949673f$export$f4897c33bb31b742(e.message, 413));
                reject(e);
            }
        }).finally(()=>{
            setIsDraftSyncPending(false);
            setIsSaving(false);
            saveDraftPromiseRef.current = null;
        });
        return saveDraftPromiseRef.current;
    }, [
        isFirstParticipant,
        getCollabProviderState,
        collabEditProvider,
        collabEditInitialized,
        contentId,
        contentType,
        experimentalDraftSyncMutation,
        onCollabError,
        getIsPublishing,
        isEditorDirty,
        draftSyncError,
        setIsDraftSyncPending,
        isLivePage
    ]);
    const saveDraftWithExperienceTracking = (0, $cozmU.useCallback)(async ({ isOnClose: isOnClose } = {})=>{
        if (isLivePage) return;
        // suppressing only `experimentalDraftSyncMutation` to match former behaviour, but it may be desirable to prevent bubbling up any draft sync errors
        if (!isOnClose) return saveDraft(false).catch((error)=>error instanceof $a885b97ec949673f$export$bae3ecc5df674a2 ? Promise.reject(error) : Promise.resolve());
        const name = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
        experienceTracker.start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                contentId: contentId,
                collabService: 'ncs',
                isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)
            }
        });
        // Track whether the content is empty on editor close. This can't be done
        // in saveDraft by storing the content length result from ackState because
        // the function short circuits for non-primary participants.
        let isContentEmpty = undefined;
        try {
            const ackState = await getCollabProviderState(false);
            const contentLength = ackState?.content?.content?.length ?? undefined;
            isContentEmpty = contentLength === undefined ? undefined : contentLength === 0;
        } catch  {
        // intentionally empty - we don't need to handle this error
        }
        // on editor close, we want to sync any unconfirmed steps before saving draft
        return saveDraft(true).then((value)=>{
            experienceTracker.succeed({
                name: name,
                attributes: {
                    contentId: contentId,
                    collabService: 'ncs',
                    ...isContentEmpty !== undefined ? {
                        isContentEmpty: isContentEmpty
                    } : {}
                }
            });
            return value;
        }, (error)=>{
            let traceId = null;
            if (!(error instanceof $a885b97ec949673f$export$bae3ecc5df674a2)) {
                const errorObj = (0, $422HI.isApolloError)(error) ? error?.graphQLErrors[0] : error;
                const statusCode = (0, $aMcHK.getStatusCode)(errorObj) || (0, $aMcHK.getStatusCode)(errorObj?.originalError);
                const numStatus = statusCode && parseInt(statusCode, 10);
                if ((0, $hBkCm.BadStatusError).isBadStatusError(errorObj) || (0, $hBkCm.BadStatusError).isBadStatusError(errorObj?.originalError)) traceId = (0, $fJlJm.getLogSafeErrorAttributes)(errorObj).traceId || errorObj?.originalError?.traceId;
                if (numStatus && !isNaN(numStatus) && numStatus >= 400 && numStatus < 500) {
                    experienceTracker.abort({
                        name: name,
                        reason: `User error with status code ${statusCode}`,
                        attributes: {
                            contentId: contentId,
                            collabService: 'ncs',
                            traceId: traceId ?? 'unknown',
                            ...isContentEmpty !== undefined ? {
                                isContentEmpty: isContentEmpty
                            } : {}
                        }
                    });
                    return;
                }
            }
            experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: {
                    contentId: contentId,
                    collabService: 'ncs',
                    traceId: traceId ?? 'unknown',
                    ...isContentEmpty !== undefined ? {
                        isContentEmpty: isContentEmpty
                    } : {}
                }
            });
        });
    }, [
        saveDraft,
        experienceTracker,
        contentId,
        spaceKey,
        getCollabProviderState,
        isLivePage
    ]);
    const debouncedSaveDraft = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(saveDraftWithExperienceTracking, $a885b97ec949673f$var$DRAFT_SYNC_TIMEOUT, {
            ...draftSyncDebounceMaxWait > 0 && {
                maxWait: draftSyncDebounceMaxWait
            }
        }), [
        saveDraftWithExperienceTracking,
        draftSyncDebounceMaxWait
    ]);
    const cancelDebouncedSaveDraft = (0, $cozmU.useCallback)(()=>debouncedSaveDraft.cancel(), [
        debouncedSaveDraft
    ]);
    const triggerSaveDraft = (0, $cozmU.useCallback)(()=>{
        if (isLivePage) return;
        setIsDraftSyncPending(true);
        debouncedSaveDraft();
    }, [
        debouncedSaveDraft,
        setIsDraftSyncPending,
        isLivePage
    ]);
    const handleOnMetadataChanged = (0, $cozmU.useCallback)((input)=>{
        // do not trigger a draft sync if it is just metadata change from the editor
        if (input?.metadataSource === 'client') triggerSaveDraft();
    }, [
        triggerSaveDraft
    ]);
    const handleDocumentUpdate = (0, $cozmU.useCallback)((input)=>{
        // do not trigger a draft sync:
        // 		- if the step is an override-document step which comes from backend RESET call (so monolith is source of truth and already in sync)
        // 		- for auto-generated analytics steps
        const isExcludedSteps = input?.json?.every((step)=>!!step.stepType && $a885b97ec949673f$var$DRAFT_SYNC_EXCLUDED_STEPS.includes(step.stepType));
        if (hasEditorContentChangedByAnyUser && !isExcludedSteps && !isLivePage) triggerSaveDraft();
    }, [
        hasEditorContentChangedByAnyUser,
        triggerSaveDraft,
        isLivePage
    ]);
    const flushSaveDraft = (0, $cozmU.useCallback)(()=>{
        debouncedSaveDraft.flush();
    }, [
        debouncedSaveDraft
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider || !collabEditInitialized || isLivePage) return;
        window.addEventListener('beforeunload', flushSaveDraft);
        return ()=>{
            window.removeEventListener('beforeunload', flushSaveDraft);
        };
    }, [
        collabEditInitialized,
        collabEditProvider,
        flushSaveDraft,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isFirstParticipant || !collabEditProvider || isLivePage) return;
        collabEditProvider.on('data', handleDocumentUpdate);
        collabEditProvider.on('metadata:changed', handleOnMetadataChanged);
        return ()=>{
            collabEditProvider.off('data', handleDocumentUpdate);
            collabEditProvider.off('metadata:changed', handleOnMetadataChanged);
        };
    }, [
        collabEditProvider,
        triggerSaveDraft,
        handleDocumentUpdate,
        isFirstParticipant,
        isLivePage,
        handleOnMetadataChanged
    ]);
    return {
        cancelDebouncedSaveDraft: // This is needed for the following occasions:
        // when user clicks on a template from the templates panel (beforeTemplateSelect)
        cancelDebouncedSaveDraft,
        triggerSaveDraft: triggerSaveDraft,
        saveDraftError: draftSyncError,
        saveDraft: saveDraftWithExperienceTracking,
        saveDraftPromise: saveDraftPromiseRef.current,
        isSavingDraft: isSaving
    };
};
module.exports["DraftSyncResponseError"] = $a885b97ec949673f$export$f4897c33bb31b742;
module.exports["useDraftSync"] = $a885b97ec949673f$export$772c75ad2e0d1281;

});

parcelRegister("16o3K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $1KOhB = parcelRequire("1KOhB");

const $62576a5397a3c55d$export$c435485c8cd980a2 = ({ editorPresetAPI: editorPresetAPI })=>{
    const [collabInitializedMetadata, setCollabInitializedMetadata] = (0, $cozmU.useState)();
    (0, $1KOhB.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        if (!collabEditState?.initialised) return;
        const newCollabInitializedMetadata = {
            collabInitialisedAt: collabEditState.initialised?.collabInitialisedAt,
            firstChangeAfterInitAt: collabEditState.initialised?.firstChangeAfterInitAt,
            firstContentBodyChangeAfterInitAt: collabEditState.initialised?.firstContentBodyChangeAfterInitAt,
            lastLocalOrganicBodyChangeAt: collabEditState.initialised?.lastLocalOrganicBodyChangeAt
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(collabInitializedMetadata, newCollabInitializedMetadata)) setCollabInitializedMetadata(newCollabInitializedMetadata);
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!collabInitializedMetadata) return {
            hasEditorContentChangedByAnyUser: false,
            hasEditorContentChangedByLocalUserExcludingComments: false
        };
        const { collabInitialisedAt: collabInitialisedAt, firstChangeAfterInitAt: firstChangeAfterInitAt, lastLocalOrganicBodyChangeAt: lastLocalOrganicBodyChangeAt, firstContentBodyChangeAfterInitAt: firstContentBodyChangeAfterInitAt } = collabInitializedMetadata;
        const isCollabInitialised = Boolean(collabInitialisedAt);
        const hasEditorContentChangedByAnyUser = isCollabInitialised && Boolean(firstChangeAfterInitAt);
        const hasEditorContentChangedByLocalUserExcludingComments = isCollabInitialised ? Boolean(lastLocalOrganicBodyChangeAt) : Boolean(firstContentBodyChangeAfterInitAt);
        return {
            hasEditorContentChangedByAnyUser: hasEditorContentChangedByAnyUser,
            hasEditorContentChangedByLocalUserExcludingComments: hasEditorContentChangedByLocalUserExcludingComments
        };
    }, [
        collabInitializedMetadata
    ]);
};
module.exports["useHasEditorContentChanged"] = $62576a5397a3c55d$export$c435485c8cd980a2;

});

parcelRegister("9pRHz", function(module, exports) {
(function() {
    'use strict';
    var collator;
    try {
        collator = typeof Intl !== "undefined" && typeof Intl.Collator !== "undefined" ? Intl.Collator("generic", {
            sensitivity: "base"
        }) : null;
    } catch (err) {
        console.log("Collator could not be initialized and wouldn't be used");
    }
    // arrays to re-use
    var prevRow = [], str2Char = [];
    /**
   * Based on the algorithm at http://en.wikipedia.org/wiki/Levenshtein_distance.
   */ var Levenshtein = {
        /**
     * Calculate levenshtein distance of the two strings.
     *
     * @param str1 String the first string.
     * @param str2 String the second string.
     * @param [options] Additional options.
     * @param [options.useCollator] Use `Intl.Collator` for locale-sensitive string comparison.
     * @return Integer the levenshtein distance (0 and above).
     */ get: function(str1, str2, options) {
            var useCollator = options && collator && options.useCollator;
            var str1Len = str1.length, str2Len = str2.length;
            // base cases
            if (str1Len === 0) return str2Len;
            if (str2Len === 0) return str1Len;
            // two rows
            var curCol, nextCol, i, j, tmp;
            // initialise previous row
            for(i = 0; i < str2Len; ++i){
                prevRow[i] = i;
                str2Char[i] = str2.charCodeAt(i);
            }
            prevRow[str2Len] = str2Len;
            var strCmp;
            if (useCollator) // calculate current row distance from previous row using collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = 0 === collator.compare(str1.charAt(i), String.fromCharCode(str2Char[j]));
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            else // calculate current row distance from previous row without collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = str1.charCodeAt(i) === str2Char[j];
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            return nextCol;
        }
    };
    // amd
    if (typeof define !== "undefined" && define !== null && define.amd) define(function() {
        return Levenshtein;
    });
    else if (module !== null && true && module.exports === exports) module.exports = Levenshtein;
    else if (typeof self !== "undefined" && typeof self.postMessage === 'function' && typeof self.importScripts === 'function') self.Levenshtein = Levenshtein;
    else if (typeof window !== "undefined" && window !== null) window.Levenshtein = Levenshtein;
})();

});

parcelRegister("biTuX", function(module, exports) {

let $83ac6cf22df30a8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83ac6cf22df30a8b$var$load("696ho").then(()=>parcelRequire('fLVvK'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("2uyII", function(module, exports) {

let $1d0950d223ce4d28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d0950d223ce4d28$var$load("jdEwy").then(()=>parcelRequire('bFIZB'));

});

parcelRegister("f4L8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1UApO = parcelRequire("1UApO");


var $cl74W = parcelRequire("cl74W");


var $d0Ide = parcelRequire("d0Ide");

const $b09fb9a971fb608f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    releaseNotesModalHeader: {
        id: "automation-discovery.rovo.release-notes.modal.header",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    releaseNotesCta: {
        id: "automation-discovery.rovo.release-notes.modal.cta",
        defaultMessage: "Automate your release notes process?"
    },
    releaseNoteKeywordForModalTrigger: {
        id: "automation-discovery.rovo.release-note.trigger.keyword",
        defaultMessage: "release note"
    }
});
const $b09fb9a971fb608f$export$cfdfdfa5ab908e86 = (pageTitle, intl)=>{
    // show the dialog if title contains "release note"
    return pageTitle.toLowerCase().includes(intl.formatMessage($b09fb9a971fb608f$export$a7357cdd1f0b0168.releaseNoteKeywordForModalTrigger));
};
const $b09fb9a971fb608f$var$ReleaseNotesDialogComponent = ({ onClose: onClose, publishedPageTitle: publishedPageTitle, spaceName: spaceName, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cl74W.BaseAutomationDiscoveryDialog), {
        eventSourceName: (0, $d0Ide.EventSourceName).RELEASE_NOTES,
        templateName: "createReleaseNotesPageAfterJiraIssueCreation",
        discoveryExperience: "automationDiscoveryReleaseNotes",
        onClose: onClose,
        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b09fb9a971fb608f$export$a7357cdd1f0b0168.releaseNotesCta),
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$b09fb9a971fb608f$export$a7357cdd1f0b0168.releaseNotesModalHeader,
            values: {
                publishedPageTitle: publishedPageTitle,
                spaceName: spaceName
            }
        }),
        localStorageKey: (0, $1UApO.keys).AUTOMATION_DISCOVER_RELEASE_NOTES,
        templateUrl: `/wiki/spaces/${spaceKey}/settings/automation#/rule/template?templateId=confluence_rovo_template_4`,
        spaceKey: spaceKey
    });
};
const $b09fb9a971fb608f$export$cdc5aab61ff017f5 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($b09fb9a971fb608f$var$ReleaseNotesDialogComponent);
module.exports["i18n"] = $b09fb9a971fb608f$export$a7357cdd1f0b0168;
module.exports["isEligibleForReleaseNotesDiscovery"] = $b09fb9a971fb608f$export$cfdfdfa5ab908e86;
module.exports["ReleaseNotesDialog"] = $b09fb9a971fb608f$export$cdc5aab61ff017f5;

});

parcelRegister("ekkfU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1UApO = parcelRequire("1UApO");


var $cl74W = parcelRequire("cl74W");


var $d0Ide = parcelRequire("d0Ide");

const $21560164069989b2$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    feedbackAnalysisModalHeader: {
        id: "automation-discovery.rovo.feedback-analysis.modal.header",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    feedbackAnalysisCta: {
        id: "automation-discovery.rovo.feedback-analysis.modal.cta",
        defaultMessage: "Automate your feedback analysis with a template?"
    },
    feedbackKeywordForModalTrigger: {
        id: "automation-discovery.rovo.feedback-analysis.feedback.trigger.keyword",
        defaultMessage: "feedback"
    },
    summaryKeywordForModalTrigger: {
        id: "automation-discovery.rovo.feedback-analysis.summary.trigger.keyword",
        defaultMessage: "summary"
    },
    analysisKeywordForModalTrigger: {
        id: "automation-discovery.rovo.feedback-analysis.analysis.trigger.keyword",
        defaultMessage: "analysis"
    }
});
const $21560164069989b2$export$fc571c51f31a336d = (pageTitle, intl)=>{
    // show the dialog if title contains "analysis" or "feedback summary"
    return pageTitle.toLowerCase().includes(intl.formatMessage($21560164069989b2$export$a7357cdd1f0b0168.analysisKeywordForModalTrigger)) || pageTitle.toLowerCase().includes(intl.formatMessage($21560164069989b2$export$a7357cdd1f0b0168.feedbackKeywordForModalTrigger)) && pageTitle.toLowerCase().includes(intl.formatMessage($21560164069989b2$export$a7357cdd1f0b0168.summaryKeywordForModalTrigger));
};
const $21560164069989b2$var$FeedbackAnalysisDialogComponent = ({ onClose: onClose, publishedPageTitle: publishedPageTitle, spaceName: spaceName, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cl74W.BaseAutomationDiscoveryDialog), {
        eventSourceName: (0, $d0Ide.EventSourceName).FEEDBACK_ANALYSIS,
        templateName: "createReleaseNotesPageAfterJiraIssueCreation",
        discoveryExperience: "automationDiscoveryFeedbackAnalysis",
        onClose: onClose,
        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $21560164069989b2$export$a7357cdd1f0b0168.feedbackAnalysisCta),
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$21560164069989b2$export$a7357cdd1f0b0168.feedbackAnalysisModalHeader,
            values: {
                publishedPageTitle: publishedPageTitle,
                spaceName: spaceName
            }
        }),
        localStorageKey: (0, $1UApO.keys).AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS,
        templateUrl: `/wiki/spaces/${spaceKey}/settings/automation#/rule/template?templateId=confluence_rovo_template_3`,
        spaceKey: spaceKey
    });
};
const $21560164069989b2$export$b4397e1c653e52c9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($21560164069989b2$var$FeedbackAnalysisDialogComponent);
module.exports["i18n"] = $21560164069989b2$export$a7357cdd1f0b0168;
module.exports["isEligibleForFeedbackAnalysisDiscovery"] = $21560164069989b2$export$fc571c51f31a336d;
module.exports["FeedbackAnalysisDialog"] = $21560164069989b2$export$b4397e1c653e52c9;

});

parcelRegister("9wXqm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1UApO = parcelRequire("1UApO");


var $cl74W = parcelRequire("cl74W");


var $d0Ide = parcelRequire("d0Ide");

const $9ebc84eb5a38eb94$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    productRequirementsModalHeader: {
        id: "automation-discovery.rovo.product-requirements.modal.header",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    productRequirementsCta: {
        id: "automation-discovery.rovo.product-requirements.modal.cta",
        defaultMessage: "Automate your product requirements work?"
    },
    productKeywordForModalTrigger: {
        id: "automation-discovery.rovo.product-requirements.product.trigger.keyword",
        defaultMessage: "product"
    },
    requirementKeywordForModalTrigger: {
        id: "automation-discovery.rovo.product-requirements.requirement.trigger.keyword",
        defaultMessage: "requirement"
    }
});
const $9ebc84eb5a38eb94$export$3db758fcd0ace282 = (pageTitle, intl)=>{
    return pageTitle.toLowerCase().includes(intl.formatMessage($9ebc84eb5a38eb94$export$a7357cdd1f0b0168.productKeywordForModalTrigger)) && pageTitle.toLowerCase().includes(intl.formatMessage($9ebc84eb5a38eb94$export$a7357cdd1f0b0168.requirementKeywordForModalTrigger));
};
const $9ebc84eb5a38eb94$var$ProductRequirementsDialogComponent = ({ onClose: onClose, publishedPageTitle: publishedPageTitle, spaceName: spaceName, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cl74W.BaseAutomationDiscoveryDialog), {
        eventSourceName: (0, $d0Ide.EventSourceName).PRODUCT_REQUIREMENTS,
        templateName: "addPRDImprovementCommentAfterPagePublished",
        discoveryExperience: "automationDiscoveryProductRequirements",
        onClose: onClose,
        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9ebc84eb5a38eb94$export$a7357cdd1f0b0168.productRequirementsCta),
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$9ebc84eb5a38eb94$export$a7357cdd1f0b0168.productRequirementsModalHeader,
            values: {
                publishedPageTitle: publishedPageTitle,
                spaceName: spaceName
            }
        }),
        localStorageKey: (0, $1UApO.keys).AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS,
        templateUrl: `/wiki/spaces/${spaceKey}/settings/automation#/rule/template?templateId=confluence_rovo_template_1`,
        spaceKey: spaceKey
    });
};
const $9ebc84eb5a38eb94$export$411af6c976369cee = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($9ebc84eb5a38eb94$var$ProductRequirementsDialogComponent);
module.exports["i18n"] = $9ebc84eb5a38eb94$export$a7357cdd1f0b0168;
module.exports["isEligibleForProductRequirementsDiscovery"] = $9ebc84eb5a38eb94$export$3db758fcd0ace282;
module.exports["ProductRequirementsDialog"] = $9ebc84eb5a38eb94$export$411af6c976369cee;

});

parcelRegister("5ueVa", function(module, exports) {
const $753b3a9d15f80592$var$PRIORITIZATION_TEMPLATE_REGEX = /road\W?map/i;
const $753b3a9d15f80592$var$PIR_TEMPLATE_REGEX = /(p[oa]st\s*incidents?\s*reviews?)|((\bPIR\b))/i;
const $753b3a9d15f80592$var$TEAM_FORMATION_TEMPLATE_REGEX = /(.+?((roles?)|(responsibilit(y|ies))).*)|(.+?((responsibilit(y|ies)|(roles?))).*)/i;
var $753b3a9d15f80592$export$e42722a8287ea6dd = /*#__PURE__*/ function(WhiteboardTemplates) {
    WhiteboardTemplates["PRIORITIZATION"] = "confluence_collaborate_template_14";
    WhiteboardTemplates["PIR"] = "confluence_collaborate_template_15";
    WhiteboardTemplates["TEAM_FORMATION"] = "confluence_collaborate_template_16";
    return WhiteboardTemplates;
}({});
const $753b3a9d15f80592$export$5c5b3d2306290e36 = (pageTitle)=>{
    if ($753b3a9d15f80592$var$PRIORITIZATION_TEMPLATE_REGEX.test(pageTitle)) return true;
    if ($753b3a9d15f80592$var$PIR_TEMPLATE_REGEX.test(pageTitle)) return true;
    if ($753b3a9d15f80592$var$TEAM_FORMATION_TEMPLATE_REGEX.test(pageTitle)) return true;
    return false;
};
const $753b3a9d15f80592$export$3672474655f563a3 = (pageTitle)=>{
    if ($753b3a9d15f80592$var$PRIORITIZATION_TEMPLATE_REGEX.test(pageTitle)) return "confluence_collaborate_template_14";
    if ($753b3a9d15f80592$var$PIR_TEMPLATE_REGEX.test(pageTitle)) return "confluence_collaborate_template_15";
    if ($753b3a9d15f80592$var$TEAM_FORMATION_TEMPLATE_REGEX.test(pageTitle)) return "confluence_collaborate_template_16";
    // Arbitrarily pick this template as the default template
    return "confluence_collaborate_template_14";
};
module.exports["WhiteboardTemplates"] = $753b3a9d15f80592$export$e42722a8287ea6dd;
module.exports["isEligibleForWhiteboardDiscovery"] = $753b3a9d15f80592$export$5c5b3d2306290e36;
module.exports["getWhiteboardTemplateByPageTitle"] = $753b3a9d15f80592$export$3672474655f563a3;

});

parcelRegister("gibc0", function(module, exports) {

let $bdc7026c85c72322$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdc7026c85c72322$var$load("1rMtp").then(()=>parcelRequire('iBcm9'));

});

parcelRegister("8Tj57", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $6a66b7e08982392d$var$forEachSmartLink = (content, handle)=>{
    const handleCard = (node)=>{
        const url = node.attrs?.url;
        if (url) handle(url);
    };
    (0, $jTt8P.traverse)(content, {
        inlineCard: handleCard,
        blockCard: handleCard,
        embedCard: handleCard
    });
};
const $6a66b7e08982392d$export$61d970d18bbeb3fb = (content, store)=>{
    const links = {};
    $6a66b7e08982392d$var$forEachSmartLink(content, (url)=>{
        const details = store.getState()[url]?.details;
        if (!details) return;
        const { name: name } = details.data;
        const { tenantId: tenantId, product: product, subproduct: subproduct } = details.meta;
        if (!name || !tenantId || product !== 'jira' || subproduct != 'software') return;
        const fullProduct = product === 'jira' ? `${product}-${subproduct}` : product;
        links[url] = {
            name: name,
            tenantId: tenantId,
            product: fullProduct
        };
    });
    return links;
};
const $6a66b7e08982392d$export$cb246b9cc90fb7ba = (content)=>{
    const links = new Set();
    $6a66b7e08982392d$var$forEachSmartLink(content, (url)=>links.add(url));
    return links;
};
module.exports["getJiraSmartLinks"] = $6a66b7e08982392d$export$61d970d18bbeb3fb;
module.exports["getAllSmartLinks"] = $6a66b7e08982392d$export$cb246b9cc90fb7ba;

});

parcelRegister("eTPUJ", function(module, exports) {

let $ad8e78c3ee7c0c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad8e78c3ee7c0c93$var$load("d3WdI").then(()=>parcelRequire('djto8'));

});

parcelRegister("f43ev", function(module, exports) {

let $af79bcbe60fa2037$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af79bcbe60fa2037$var$load("j0LQt").then(()=>parcelRequire('f7rmH'));

});

parcelRegister("aI2kO", function(module, exports) {

let $7cbfd30b1efefb9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cbfd30b1efefb9c$var$load("2PC7K").then(()=>parcelRequire('aB8OY'));

});

parcelRegister("94zJ6", function(module, exports) {

let $69b0334df901bc9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69b0334df901bc9c$var$load("iJhPP").then(()=>parcelRequire('99CHp'));

});

parcelRegister("cMPkq", function(module, exports) {

let $94f1c88218122142$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94f1c88218122142$var$load("dk3jn").then(()=>parcelRequire('1VNRq'));

});

parcelRegister("eLq1D", function(module, exports) {

let $abf9a48f06c230bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $abf9a48f06c230bc$var$load("k6GEP").then(()=>parcelRequire('4DIaR'));

});

parcelRegister("gK0U7", function(module, exports) {

let $c301a4c3e0b7b8d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c301a4c3e0b7b8d1$var$load("7jSKS").then(()=>parcelRequire('9zBVb'));

});

parcelRegister("it4xm", function(module, exports) {

let $d71e7464ae510088$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d71e7464ae510088$var$load("3Qfsq").then(()=>parcelRequire('9ENfw'));

});

parcelRegister("dLfzp", function(module, exports) {

let $a04bbe0a32e69878$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a04bbe0a32e69878$var$load("7GQ8M").then(()=>parcelRequire('jNXeA'));

});

parcelRegister("603q5", function(module, exports) {

let $45e56541104fbb7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45e56541104fbb7c$var$load("kBMsF").then(()=>parcelRequire('9HpAa'));

});

parcelRegister("kd1Fx", function(module, exports) {

let $eb6650f68217cbfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb6650f68217cbfa$var$load("ec4Qp").then(()=>parcelRequire('aSqIU'));

});

parcelRegister("gu9Dy", function(module, exports) {

let $c006ec5f2d6422f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c006ec5f2d6422f2$var$load("8MZuS").then(()=>parcelRequire('aMg37'));

});

parcelRegister("9wtut", function(module, exports) {

let $6eedfa6731854b42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eedfa6731854b42$var$load("9yNnQ").then(()=>parcelRequire('tA6i1'));

});

parcelRegister("eyMmF", function(module, exports) {

let $a999c1e21d6f6891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a999c1e21d6f6891$var$load("CPuLm").then(()=>parcelRequire('bZD4n'));

});

parcelRegister("eql0N", function(module, exports) {

let $a803cae5ce122f7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a803cae5ce122f7f$var$load("8jVxk").then(()=>parcelRequire('e1MEU'));

});

parcelRegister("eWGlR", function(module, exports) {

let $ae17559ac4cfeef7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae17559ac4cfeef7$var$load("6He3q").then(()=>parcelRequire('e2OS1'));

});

parcelRegister("i82BK", function(module, exports) {

let $d32aff34a843fed0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d32aff34a843fed0$var$load("htEln").then(()=>parcelRequire('hOWvB'));

});

parcelRegister("l68Go", function(module, exports) {

let $f5c0e4bbb0e08554$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5c0e4bbb0e08554$var$load("4jRiJ").then(()=>parcelRequire('uj6M9'));

});

parcelRegister("5XaB2", function(module, exports) {

let $455aaeacf8506220$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $455aaeacf8506220$var$load("3nlHO").then(()=>parcelRequire('bVZea'));

});

parcelRegister("6vmAY", function(module, exports) {

let $4bc72a4dacc76e3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc72a4dacc76e3f$var$load("jUPAX").then(()=>parcelRequire('2HD8a'));

});

parcelRegister("ce9ip", function(module, exports) {

let $8e6e00d3c59a3f5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e6e00d3c59a3f5d$var$load("93qOp").then(()=>parcelRequire('eeaJ4'));

});

parcelRegister("3OB9i", function(module, exports) {

let $2c72dba084dac8f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c72dba084dac8f5$var$load("jufs1").then(()=>parcelRequire('8DTCt'));

});

parcelRegister("gChog", function(module, exports) {

let $c18daf4a13477efe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c18daf4a13477efe$var$load("7JQEg").then(()=>parcelRequire('95axg'));

});

parcelRegister("aPArw", function(module, exports) {

let $7e2aef9b085231f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e2aef9b085231f6$var$load("5lcGz").then(()=>parcelRequire('hqmUq'));

});

parcelRegister("8tDV2", function(module, exports) {

let $62bfff3a1a8fff0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62bfff3a1a8fff0f$var$load("bu2ij").then(()=>parcelRequire('5mvBd'));

});

parcelRegister("e9owJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $04e9M = parcelRequire("04e9M");


var $ajdQJ = parcelRequire("ajdQJ");

const $396d5d87f7823127$export$6f02d285bbc0f4c3 = ({ blueprintType: blueprintType, contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, source: source, subject: subject, version: version, collabService: collabService })=>{
    const triggerAnalyticsEvent = (0, $cozmU.useMemo)(()=>async (eventName, extraData = {})=>{
            const analyticDetails = {
                contentId: contentId,
                contentType: (0, $ajdQJ.markAsSafe)('page', 'blogpost')(contentType),
                blueprintType: (0, $ajdQJ.dangerouslyCreateSafeString)(blueprintType),
                editorVersion: (0, $ajdQJ.markAsSafe)('fabric', 'tinymce')('fabric'),
                version: version || null,
                collabService: collabService,
                ...embeddedConfluenceSource && {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                ...extraData
            };
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            await client.sendTrackEvent({
                action: eventName,
                actionSubject: subject,
                source: source,
                objectType: contentType,
                objectId: contentId,
                attributes: analyticDetails
            });
        }, [
        blueprintType,
        contentId,
        contentType,
        embeddedConfluenceSource,
        source,
        subject,
        version,
        collabService
    ]);
    return {
        triggerAnalyticsEvent: triggerAnalyticsEvent
    };
};
module.exports["useEditorAnalyticsEvent"] = $396d5d87f7823127$export$6f02d285bbc0f4c3;

});

parcelRegister("bUSKZ", function(module, exports) {
/**
 * @generated SignedSource<<08cb1a8cf0bff95ca203f4c28751de66>>
 * @relayHash d147836e60ff51352bf0f1bd546feca4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35c4ec47efcd810b834eb6c04bc90699cf30d4bbbb478bcec9631cca76a4c516
const $6798ffd9144f7a65$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "migratedRecently"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMigratedRecentlyMigratedRecentlyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMigratedRecentlyMigratedRecentlyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d147836e60ff51352bf0f1bd546feca4",
            "id": "35c4ec47efcd810b834eb6c04bc90699cf30d4bbbb478bcec9631cca76a4c516",
            "metadata": {},
            "name": "useMigratedRecentlyMigratedRecentlyQuery",
            "operationKind": "query",
            "text": "query useMigratedRecentlyMigratedRecentlyQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{migratedRecently}}}}}"
        }
    };
}();
$6798ffd9144f7a65$var$node.hash = "b40f774bad57acf133d091b1d654a206";
var $6798ffd9144f7a65$export$2e2bcd8739ae039 = $6798ffd9144f7a65$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $258c946a67e49b08$export$329058600facf1cc = (contentId)=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $6798ffd9144f7a65$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/editor-features"
    });
    if (loading || error) return false;
    return data?.content?.nodes?.[0]?.metadata?.frontend?.migratedRecently || false;
};
module.exports["useMigratedRecently"] = $258c946a67e49b08$export$329058600facf1cc;

});

parcelRegister("duCvb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");








var $kh0hi = parcelRequire("kh0hi");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");

const $d16be98e2a14ebd2$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkCTA: {
        id: "editor-features.user.copy-your-page",
        defaultMessage: "Copy link"
    },
    copiedCTA: {
        id: "editor-features.user.copied-page",
        defaultMessage: "Copied"
    }
});
const $d16be98e2a14ebd2$var$linkStyles = (0, $buxP3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.link',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    padding: 'space.0',
    paddingRight: 'space.025',
    cursor: 'pointer',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus-visible': {
        outlineStyle: 'auto',
        // @ts-expect-error - outlineOffset currently doesn't expect negative values
        outlineOffset: '-1px'
    }
});
const $d16be98e2a14ebd2$var$copiedLinkStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    cursor: 'default',
    ':hover': {
        textDecoration: 'none'
    },
    ':focus-visible': {
        outlineStyle: 'none'
    }
});
const $d16be98e2a14ebd2$export$82e0fc2f3003062b = ({ successPublishMessage: successPublishMessage, copyContentLink: copyContentLink, createAnalyticsEvent: createAnalyticsEvent, isFirstTimePublish: isFirstTimePublish })=>{
    const [isLinkCopied, setLinkCopied] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isLinkCopied) {
            const timeout = setTimeout(()=>{
                setLinkCopied(false);
            }, 4000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        isLinkCopied
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isLinkCopied) return;
        setLinkCopied(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'publishFlagCopyPageCTA',
                source: 'publishSuccessFlag',
                attributes: {
                    isFirstTimePublish: isFirstTimePublish
                }
            }
        }).fire();
        copyContentLink();
    }, [
        isLinkCopied,
        setLinkCopied,
        copyContentLink,
        createAnalyticsEvent,
        isFirstTimePublish
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, successPublishMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle",
        xcss: [
            $d16be98e2a14ebd2$var$linkStyles,
            isLinkCopied && $d16be98e2a14ebd2$var$copiedLinkStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isLinkCopied ? $d16be98e2a14ebd2$var$i18n.copiedCTA : $d16be98e2a14ebd2$var$i18n.copyLinkCTA)));
};


const $770b257aa1f4b782$export$4fb0801f02d2f353 = 11000;
const $770b257aa1f4b782$var$i18n = (0, $kSwu1.defineMessages)({
    publishSuccessTitle: {
        id: "editor-features.success.publish.title",
        defaultMessage: "Published!"
    },
    updateSuccessTitle: {
        id: "editor-features.success.update.title",
        defaultMessage: "Updated!"
    },
    convertAndPublishSuccessTitle: {
        id: "editor-features.success.convertAndPublish.title",
        defaultMessage: "Converted and published!"
    },
    publishSuccessMessageWithSpaceName: {
        id: "editor-features.user.publish.success.with.space.name",
        defaultMessage: "{pageTitle} was successfully published in the {spaceName} space"
    },
    updateSuccessMessageWithSpaceName: {
        id: "editor-features.user.update.success.with.space.name",
        defaultMessage: "{pageTitle} was successfully updated in the {spaceName} space"
    },
    publishSuccessMessage: {
        id: "editor-features.user.publish.success",
        defaultMessage: "{pageTitle} was successfully published"
    },
    updateSuccessMessage: {
        id: "editor-features.user.update.success",
        defaultMessage: "{pageTitle} was successfully updated"
    },
    convertAndPublishSuccessMessage: {
        id: "editor-features.user.convertAndPublish.success",
        defaultMessage: "{pageTitle} was converted to a page and published."
    },
    publishSuccessTitleWithSocial: {
        id: "editor-features.publish.success.title.with.social",
        defaultMessage: "Page successfully published"
    },
    publishSuccessMessageWithSocial: {
        id: "editor-features.publish.success.message.with.social",
        defaultMessage: "Share this page to ensure your team can see and build on your contributions."
    },
    sharePageCTA: {
        id: "editor-features.publish.success.share-page",
        defaultMessage: "Share page"
    }
});
const $770b257aa1f4b782$var$getFlagStrings = ({ isFirstTimePublish: isFirstTimePublish, hasSpaceName: hasSpaceName, isConvertingFromLivePage: isConvertingFromLivePage })=>{
    if (isConvertingFromLivePage) return {
        title: $770b257aa1f4b782$var$i18n.convertAndPublishSuccessTitle,
        message: $770b257aa1f4b782$var$i18n.convertAndPublishSuccessMessage
    };
    else {
        if (isFirstTimePublish) return {
            title: $770b257aa1f4b782$var$i18n.publishSuccessTitle,
            message: hasSpaceName ? $770b257aa1f4b782$var$i18n.publishSuccessMessageWithSpaceName : $770b257aa1f4b782$var$i18n.publishSuccessMessage
        };
        else return {
            title: $770b257aa1f4b782$var$i18n.updateSuccessTitle,
            message: hasSpaceName ? $770b257aa1f4b782$var$i18n.updateSuccessMessageWithSpaceName : $770b257aa1f4b782$var$i18n.updateSuccessMessage
        };
    }
};
const $770b257aa1f4b782$export$6e7f577612d14ed = async ({ isFirstTimePublish: isFirstTimePublish, shouldTimeout: shouldTimeout = true, spaceName: spaceName, flags: flags, title: title, intl: intl, copyContentLink: copyContentLink, createAnalyticsEvent: createAnalyticsEvent, isConvertingFromLivePage: isConvertingFromLivePage = false })=>{
    const flagStrings = $770b257aa1f4b782$var$getFlagStrings({
        isFirstTimePublish: isFirstTimePublish,
        hasSpaceName: !!spaceName,
        isConvertingFromLivePage: isConvertingFromLivePage
    });
    const messageData = {
        spaceName: spaceName,
        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, title)
    };
    let flagProps = {};
    if (copyContentLink && createAnalyticsEvent) flagProps = {
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d16be98e2a14ebd2$export$82e0fc2f3003062b), {
            copyContentLink: copyContentLink,
            successPublishMessage: intl.formatMessage(flagStrings.message, messageData),
            createAnalyticsEvent: createAnalyticsEvent,
            isFirstTimePublish: isFirstTimePublish
        })
    };
    const publishSuccessFlag = await flags.showFlag({
        type: 'success-circle',
        title: intl.formatMessage(flagStrings.title),
        description: intl.formatMessage(flagStrings.message, messageData),
        close: 'never',
        messageId: 'confluence-frontend-editor-features-publish-success-flag',
        messageType: 'transactional',
        ...flagProps
    });
    if (shouldTimeout) setTimeout(()=>flags.hideFlag(publishSuccessFlag.id), $770b257aa1f4b782$export$4fb0801f02d2f353);
};
module.exports["showPublishSuccessFlags"] = $770b257aa1f4b782$export$6e7f577612d14ed;

});

parcelRegister("lREFo", function(module, exports) {
/**
 * @generated SignedSource<<1a2b634a842f25bfd8dcffec232ec85c>>
 * @relayHash 5739cedf14c2d79a92d1595bb5ab39bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74baecdead55bb37e9dafab316c22eb29bcd811fe3ea782224b5bc34d942374f
const $51220548dad7da68$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBlueprintTypeEditorEditorLabelsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBlueprintTypeEditorEditorLabelsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "5739cedf14c2d79a92d1595bb5ab39bc",
            "id": "74baecdead55bb37e9dafab316c22eb29bcd811fe3ea782224b5bc34d942374f",
            "metadata": {},
            "name": "useBlueprintTypeEditorEditorLabelsQuery",
            "operationKind": "query",
            "text": "query useBlueprintTypeEditorEditorLabelsQuery($contentId:ID!){content(id:$contentId){nodes{id,labels{nodes{id,name}}}}}"
        }
    };
}();
$51220548dad7da68$var$node.hash = "8e81347d292c21680357fc15576d537d";
var $51220548dad7da68$export$2e2bcd8739ae039 = $51220548dad7da68$var$node;


const $e6cf1f9c6fe89175$export$3e2a3fad4e0315ba = {
    'meeting-notes': 'content.kind.meeting-notes',
    decisions: 'content.kind.decisions',
    'kb-how-to-article': 'content.kind.kb-how-to-article',
    'file-list': 'content.kind.file-list',
    retrospective: 'content.kind.retrospective',
    requirements: 'content.kind.product-requirements',
    'shared-links': 'content.kind.shared-links',
    'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
    'task-report': 'content.kind.task-report',
    jirareport: 'content.kind.jirareport'
};



var $jMyy4 = parcelRequire("jMyy4");

const $68c0e786f3988e09$export$5263310017cc26c7 = (labels)=>{
    for (const label of labels){
        const value = (0, $e6cf1f9c6fe89175$export$3e2a3fad4e0315ba)[label];
        if (value !== undefined) return label;
    }
    return '';
};
const $68c0e786f3988e09$export$dff5166dabf9b575 = (data)=>{
    const labels = data?.content?.nodes?.[0]?.labels?.nodes?.map((x)=>x.name) ?? [];
    return $68c0e786f3988e09$export$5263310017cc26c7(labels);
};
const $68c0e786f3988e09$export$6b2f2d2ab57962f0 = (contentId, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $51220548dad7da68$export$2e2bcd8739ae039), {
        skip: skip,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/editor-features"
    });
    if (loading || error) return '';
    return $68c0e786f3988e09$export$dff5166dabf9b575(data);
};
module.exports["getBlueprintFromLabels"] = $68c0e786f3988e09$export$dff5166dabf9b575;
module.exports["useBlueprintType"] = $68c0e786f3988e09$export$6b2f2d2ab57962f0;

});

parcelRegister("b4kc6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b9966337876d6919$var$SYNC_BLOCK_ERROR_FLAG_ID = 'flush-sync-block-error';
const $b9966337876d6919$var$i18n = (0, $kSwu1.defineMessages)({
    syncBlockErrorTitle: {
        id: "editor-features.error.sourceSyncBlock.save.title",
        defaultMessage: "Error saving synced block"
    },
    syncBlockErrorDescription: {
        id: "editor-features.error.sourceSyncBlock.description",
        defaultMessage: "We failed to save your recent updates. Please check your connection and try again."
    },
    syncBlockErrorRetry: {
        id: "editor-features.error.syncBlock.retry",
        defaultMessage: "Retry"
    }
});
const $b9966337876d6919$export$530e015c6fd2f029 = (flags, intl, retry)=>{
    flags?.showErrorFlag({
        id: $b9966337876d6919$var$SYNC_BLOCK_ERROR_FLAG_ID,
        title: intl.formatMessage($b9966337876d6919$var$i18n.syncBlockErrorTitle),
        description: intl.formatMessage($b9966337876d6919$var$i18n.syncBlockErrorDescription),
        isAutoDismiss: true,
        actions: [
            {
                content: intl.formatMessage($b9966337876d6919$var$i18n.syncBlockErrorRetry),
                onClick: async ()=>{
                    flags.hideFlag($b9966337876d6919$var$SYNC_BLOCK_ERROR_FLAG_ID);
                    const retrySuccess = await retry?.();
                    if (!retrySuccess) $b9966337876d6919$export$530e015c6fd2f029(flags, intl, retry);
                }
            }
        ]
    });
};
module.exports["showFlushSyncBlockErrorFlag"] = $b9966337876d6919$export$530e015c6fd2f029;

});

parcelRegister("hwk5r", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5hAil = parcelRequire("5hAil");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $cEgMD = parcelRequire("cEgMD");

const $0cdcc545b89f8eb3$export$3e7cd63adb280a34 = {
    CREATE_FULL_EDIT_PAGE: {
        page: 'title.add.page',
        blogpost: 'title.add.blogpost'
    },
    EDIT_FULL_EDIT_PAGE: {
        page: 'document-title.edit.name',
        blogpost: 'document-title.edit.name'
    },
    CREATE_TEMPLATE_PAGE: {
        page: 'title.add.page.template'
    },
    EDIT_TEMPLATE_PAGE: {
        page: 'document-title.edit.page.template'
    }
};



var $3zetf = parcelRequire("3zetf");

const $e8df92f16ad91eef$var$i18n = (0, $kSwu1.defineMessages)({
    companyHubDefaultTitleI18n: {
        id: "document-title.document-edit-page-title.company-hub.title",
        defaultMessage: "Company hub"
    },
    editName: {
        id: "document-title.edit.name",
        defaultMessage: "Edit"
    },
    editTemplatePage: {
        id: "document-title.edit.page.template",
        defaultMessage: "Edit template"
    }
});
const $e8df92f16ad91eef$var$toTitleString = (texts)=>{
    return texts.filter((i)=>i).join(' - ');
};
const $e8df92f16ad91eef$export$c8de3f10adfec339 = (0, $kSwu1.injectIntl)(({ content: content = {}, contentType: contentType = 'page', intl: intl, isCreatingNew: isCreatingNew, isTemplateEditPage: isTemplateEditPage, isLivePage: isLivePage, spaceKey: spaceKey, title: title })=>{
    const { siteTitle: siteTitle, companyHubName: companyHubName } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5hAil.QueryGroup), {
        queryProps: (0, $3zetf.getSpaceNameQueryProps)(spaceKey)
    }, ({ results: results, loading: loading })=>{
        if (loading) return null;
        const spaceName = (0, $3zetf.getSpaceNameFromResults)(results);
        let docTitle;
        if (isCreatingNew) {
            const titleI18nKey = {
                id: (isTemplateEditPage ? (0, $0cdcc545b89f8eb3$export$3e7cd63adb280a34).CREATE_TEMPLATE_PAGE : (0, $0cdcc545b89f8eb3$export$3e7cd63adb280a34).CREATE_FULL_EDIT_PAGE)[contentType]
            };
            const instruction = intl.formatMessage(titleI18nKey);
            docTitle = isTemplateEditPage ? $e8df92f16ad91eef$var$toTitleString([
                instruction,
                title,
                spaceName,
                siteTitle
            ]) : // new draft: title will be whatever string user type into title text field
            // unpublished draft: title is undefined, have to get title from content.title
            $e8df92f16ad91eef$var$toTitleString([
                instruction,
                title || content?.title,
                spaceName,
                siteTitle
            ]);
        } else {
            const titleI18n = isTemplateEditPage ? $e8df92f16ad91eef$var$i18n.editTemplatePage : $e8df92f16ad91eef$var$i18n.editName;
            const prefix = isLivePage ? '' : intl.formatMessage(titleI18n);
            const companyHubSpaceName = companyHubName || intl.formatMessage($e8df92f16ad91eef$var$i18n.companyHubDefaultTitleI18n);
            docTitle = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? $e8df92f16ad91eef$var$toTitleString([
                prefix,
                companyHubSpaceName,
                siteTitle
            ]) : $e8df92f16ad91eef$var$toTitleString([
                prefix,
                title ?? content?.title,
                spaceName,
                siteTitle
            ]);
        }
        // set for SSR document title
        window.__DOCUMENT_TITLE_TAG__ = docTitle;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
            title: docTitle
        });
    }));
});
module.exports["DocumentEditPageTitle"] = $e8df92f16ad91eef$export$c8de3f10adfec339;

});

parcelRegister("8Vmxc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $bQm3c = parcelRequire("bQm3c");


var $8Tj57 = parcelRequire("8Tj57");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $0fd2f9e99abe54b2$var$MAX_DISMISSAL_COUNT = 2;
const $0fd2f9e99abe54b2$export$c509de4446dd8f14 = ()=>{
    const dismissalCount = $0fd2f9e99abe54b2$var$getDismissalCount();
    return dismissalCount >= $0fd2f9e99abe54b2$var$MAX_DISMISSAL_COUNT;
};
const $0fd2f9e99abe54b2$export$df91f816b0924368 = ()=>{
    const dismissalCount = $0fd2f9e99abe54b2$var$getDismissalCount();
    if (dismissalCount < $0fd2f9e99abe54b2$var$MAX_DISMISSAL_COUNT) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).INVITE_ON_LINK_INSERT_DISMISSAL_COUNT, (dismissalCount + 1).toString());
};
const $0fd2f9e99abe54b2$var$getDismissalCount = ()=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).INVITE_ON_LINK_INSERT_DISMISSAL_COUNT);
    return isNaN(parseInt(value)) ? 0 : parseInt(value);
};
const $0fd2f9e99abe54b2$export$ba6b48d01450a592 = ()=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).INVITE_ON_LINK_INSERT_OPT_OUT);
const $0fd2f9e99abe54b2$export$e0a1da35077dec46 = ()=>(0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).INVITE_ON_LINK_INSERT_OPT_OUT, 'true');



var $pUzjH = parcelRequire("pUzjH");

const $0707e06618735489$export$953ec2f2544e230f = async (jiraCloudId, confluenceCloudId, pageId, userId, accountIds)=>{
    const response = await fetch('/gateway/api/growth/invite-on-link-insert-confluence/get-invitees', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            jiraCloudId: jiraCloudId,
            confluenceCloudId: confluenceCloudId,
            pageId: pageId,
            userId: userId,
            accountIds: accountIds
        })
    });
    return await response.json();
};


const $205f5b9bcc923a44$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $205f5b9bcc923a44$export$f757fae6e9facd6f = async (confluenceCloudId, userId)=>{
    const payload = {
        context: {
            contextType: 'inviteOnLinkInsertConfluence',
            principalId: userId,
            siteId: confluenceCloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $205f5b9bcc923a44$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json()).collaborationGraphEntities.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, email: email, picture: picture } })=>({
            id: account_id,
            name: name,
            email: email,
            avatar: picture
        }));
    return result;
};


const $a79c3911132ae713$export$5f5d669200f1eee2 = async ({ userId: userId, confluenceCloudId: confluenceCloudId, pageId: pageId, jiraCloudId: jiraCloudId })=>{
    if (!userId) return [];
    if (await (0, $pUzjH.isSiteOptedOut)(confluenceCloudId)) return [];
    const collaborators = await (0, $205f5b9bcc923a44$export$f757fae6e9facd6f)(confluenceCloudId, userId);
    if (!collaborators || collaborators.length === 0) return [];
    const accountIds = collaborators.map((c)=>c.id);
    const response = await (0, $0707e06618735489$export$953ec2f2544e230f)(jiraCloudId, confluenceCloudId, pageId, userId, accountIds);
    if (response.ineligibilityReason === undefined || response.ineligibilityReason === null) return collaborators.filter((c)=>response.accountIds.includes(c.id));
    else return [];
};








/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 



var $kSwu1 = parcelRequire("kSwu1");


var $FKQbh = parcelRequire("FKQbh");


var $ixfCV = parcelRequire("ixfCV");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");







/* eslint-disable import/dynamic-import-chunkname */ 


function $7f6f9c4583325950$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $7f6f9c4583325950$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}

























function $7f6f9c4583325950$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("eTPUJ"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("f43ev"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("aI2kO"));
        case 'en-GB':
            return (parcelRequire("94zJ6"));
        case 'en-US':
        case 'en':
            return (parcelRequire("cMPkq"));
        case 'en-ZZ':
            return (parcelRequire("eLq1D"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("gK0U7"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("it4xm"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("dLfzp"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("603q5"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("kd1Fx"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("gu9Dy"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("9wtut"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("eyMmF"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("eql0N"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("eWGlR"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("i82BK"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("l68Go"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("5XaB2"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("6vmAY"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("ce9ip"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("3OB9i"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("gChog"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("aPArw"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("8tDV2"));
    }
    return Promise.resolve({
        default: {}
    });
}


const $a32b880d9fff35bb$export$2a4cd3780f93f2ef = (ComponentToWrap)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a32b880d9fff35bb$export$9deb723ab5a74946, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentToWrap, props));
const $a32b880d9fff35bb$export$9deb723ab5a74946 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { messages: messages } = (0, $7f6f9c4583325950$export$5ac26fa9b941854e)(locale);
    let t1;
    if ($[0] !== children || $[1] !== locale || $[2] !== messages) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            messages: messages,
            key: locale,
            locale: locale
        }, children);
        $[0] = children;
        $[1] = locale;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { messages: messages } = (0, $7f6f9c4583325950$export$5ac26fa9b941854e)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        messages: messages,
        key: locale,
        locale: locale
    }, children);
};












var $hekY6 = parcelRequire("hekY6");


var $7zsi1 = parcelRequire("7zsi1");


var $bcDqz = parcelRequire("bcDqz");

const $d938fcde960fce4c$export$29beada2d5f93289 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let data;
    let props;
    if ($[0] !== t0) {
        ({ data: data, ...props } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = props;
    } else {
        data = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== data) {
        t1 = $d938fcde960fce4c$export$bc55c1ff86d63c4d({
            data: data
        });
        $[3] = data;
        $[4] = t1;
    } else t1 = $[4];
    const { data: customData, overrides: customOverrides } = t1;
    let t2;
    if ($[5] !== customData || $[6] !== customOverrides || $[7] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
            maxCount: 999,
            data: customData,
            overrides: customOverrides,
            boundariesElement: "scrollParent",
            tooltipPosition: "top",
            size: "small",
            onMoreClick: $d938fcde960fce4c$var$_temp,
            ...props
        });
        $[5] = customData;
        $[6] = customOverrides;
        $[7] = props;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $cozmU.useMemo)(()=>$d938fcde960fce4c$export$bc55c1ff86d63c4d({
            data: data
        }), [
        data
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
        maxCount: 999,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        size: "small",
        onMoreClick: ()=>{},
        ...props
    });
};
const $d938fcde960fce4c$var$MAX_AVATARS_FEATURED = 2;
const $d938fcde960fce4c$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $d938fcde960fce4c$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $d938fcde960fce4c$export$bc55c1ff86d63c4d = ({ data: users })=>{
    const overflows = users.length > $d938fcde960fce4c$var$MAX_AVATARS_FEATURED;
    const lastFeaturedUser = $d938fcde960fce4c$var$MAX_AVATARS_FEATURED - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $d938fcde960fce4c$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $d938fcde960fce4c$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ $cozmU.createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $d938fcde960fce4c$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $d938fcde960fce4c$var$OVERFLOW_USER_MARKER
    });
const $d938fcde960fce4c$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ $cozmU.createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ $cozmU.createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_4cvr1h6o _6a6z1h6o _11c8wadc _1bsb1osq _4t3i1osq _1e0c11p5 _bfhki8nm _syazi7uo _y3gn1h6o _k48p1wq8"
        ])
    }, `+${Math.min(overflowCount, $d938fcde960fce4c$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
const $d938fcde960fce4c$var$avatarOverflowCountContainer = null;
function $d938fcde960fce4c$var$_temp() {}





const $b7bae8a4c82527b9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    addPeopleButton: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
        defaultMessage: "{inviteeCount, plural, one {Add {firstName}} other {Add # people}}"
    },
    dismiss: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
        defaultMessage: "Don't show again"
    },
    titleGeneric: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
        defaultMessage: "{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}"
    },
    descriptionWithoutPageTitleGeneric: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
        defaultMessage: "{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view an issue you added.} other {# of your collaborators need access to <strong>Jira</strong> to view an issue you added.}}"
    },
    descriptionWithPageTitleGeneric: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
        defaultMessage: "{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view <strong>{title}</strong>.} other {# of your collaborators need access to <strong>Jira</strong> to view <strong>{title}</strong>.}}"
    },
    descriptionWithoutPageTitleGenericIssueTermRefresh: {
        id: "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic-issue-term-refresh",
        defaultMessage: "{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view a work item you added.} other {# of your collaborators need access to <strong>Jira</strong> to view a work item you added.}}"
    }
});


const $e168de3e4fd2412a$export$ae9991046d9c10b0 = ({ invitees: invitees, targetTitle: targetTitle, targetProduct: targetProduct, shouldOpenCoreInvites: shouldOpenCoreInvites, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, onOpenCoreInvites: onOpenCoreInvites, ...props })=>{
    const firstName = invitees[0].name.split(' ')[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const allActions = [
        {
            content: formatMessage((0, $b7bae8a4c82527b9$export$defe85febe8b728c).addPeopleButton, {
                inviteeCount: invitees.length,
                firstName: firstName
            }),
            onClick: onSubmit
        },
        {
            content: formatMessage((0, $b7bae8a4c82527b9$export$defe85febe8b728c).dismiss, {}),
            onClick: onOptOut
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        testId: "invite-prompt",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d938fcde960fce4c$export$29beada2d5f93289), {
            data: invitees.map((user)=>({
                    name: user.name,
                    src: user.avatar
                })),
            boundariesElement: "scrollParent"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $b7bae8a4c82527b9$export$defe85febe8b728c).titleGeneric, {
            inviteeCount: invitees.length,
            displayName: invitees[0].name
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $e168de3e4fd2412a$var$mainContentContainerStyles,
            as: "p"
        }, targetTitle ? formatMessage((0, $b7bae8a4c82527b9$export$defe85febe8b728c).descriptionWithPageTitleGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: invitees.length,
            title: targetTitle,
            firstName: firstName
        }) : formatMessage((0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? (0, $b7bae8a4c82527b9$export$defe85febe8b728c).descriptionWithoutPageTitleGenericIssueTermRefresh : (0, $b7bae8a4c82527b9$export$defe85febe8b728c).descriptionWithoutPageTitleGeneric, {
            inviteeCount: invitees.length,
            firstName: firstName
        })),
        actions: onOptOut ? allActions : allActions.slice(0, 1)
    });
};
const $e168de3e4fd2412a$export$d6bef3efd7271258 = (0, $a32b880d9fff35bb$export$2a4cd3780f93f2ef)($e168de3e4fd2412a$export$ae9991046d9c10b0);
const $e168de3e4fd2412a$var$mainContentContainerStyles = (0, $buxP3.xcss)({
    display: '-webkit-box',
    lineClamp: '3',
    boxOrient: 'vertical',
    overflow: 'hidden',
    margin: 'space.0'
});



var $4wqa6 = parcelRequire("4wqa6");


var $7avaU = parcelRequire("7avaU");









var $1ApN2 = parcelRequire("1ApN2");

const $f0af817f11d386cd$export$359310a05698289 = ()=>{
    const deps = (0, $cozmU.useMemo)(()=>({}), []);
    return (0, $1ApN2.useService)((0, $4wqa6.invite), deps);
};















var $chu6R = parcelRequire("chu6R");









const $0f516342e33439d8$export$2a1baa97ca79d572 = {
    confluence: 'Confluence',
    'jira-core': 'Jira Work Management',
    'jira-product-discovery': 'Jira Product Discovery',
    'jira-servicedesk': 'Jira Service Management',
    'jira-software': 'Jira Software',
    townsquare: 'Atlas',
    bitbucket: 'Bitbucket'
};
const $0f516342e33439d8$export$44fea6589b7ddc92 = (product)=>$0f516342e33439d8$export$2a1baa97ca79d572[product];


const $4f4b36262f13b480$export$51d626641d2bcfe7 = (string)=>{
    let len = 0;
    for (const _ch of string)len++;
    return len;
};
const $4f4b36262f13b480$export$ba5f2497ec3e56ff = (string, maxLength)=>{
    let len = 0;
    let result = '';
    for (const ch of string){
        if (len++ >= maxLength) break;
        result += ch;
    }
    return result;
};
const $4f4b36262f13b480$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if ($4f4b36262f13b480$export$51d626641d2bcfe7(string) > maxLength) return `${$4f4b36262f13b480$export$ba5f2497ec3e56ff(string, maxLength - 3)}...`;
    return string;
};





const $51c0b753466c6f65$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "invite-prompt.invite-success-flag.title",
        defaultMessage: "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    descriptionGenericOne: {
        id: "invite-prompt.invite-success-flag.description-generic.one",
        defaultMessage: "We emailed <strong>{inviteeEmailOrName}</strong> inviting them to {productDisplayName}."
    },
    descriptionGenericPlural: {
        id: "invite-prompt.invite-success-flag.description-generic.plural",
        defaultMessage: "We emailed <strong>{inviteeCount} people</strong> inviting them to {productDisplayName}."
    },
    additionalInfoGeneric: {
        id: "invite-prompt.invite-success-flag.additional-info-generic",
        defaultMessage: "Some people might need your admin's approval before they can join {productDisplayName}."
    }
});


const $7efa8cd547614dec$var$MAX_LENGTH = 25;
const $7efa8cd547614dec$export$6c436beee6e5593 = (0, $a32b880d9fff35bb$export$2a4cd3780f93f2ef)(({ invitees: invitees, onDismiss: onDismiss, product: product, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const inviteeEmailOrName = (0, $4f4b36262f13b480$export$96ce25bdd1856c70)(invitees[0].email ?? invitees[0].name, $7efa8cd547614dec$var$MAX_LENGTH);
    const productDisplayName = (0, $0f516342e33439d8$export$44fea6589b7ddc92)(product);
    const customFlagFooterProps = (0, $cozmU.useMemo)(()=>({
            actions: [
                {
                    content: '',
                    onClick: ()=>{}
                }
            ],
            linkComponent: class extends (0, $cozmU.PureComponent) {
                render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                        as: "p",
                        xcss: $7efa8cd547614dec$var$footerStyles
                    }, formatMessage((0, $51c0b753466c6f65$export$defe85febe8b728c).additionalInfoGeneric, {
                        productDisplayName: productDisplayName
                    }));
                }
            }
        }), [
        formatMessage,
        productDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        ...customFlagFooterProps,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            as: "p",
            xcss: $7efa8cd547614dec$var$subtleColorStyles
        }, formatMessage((0, $51c0b753466c6f65$export$defe85febe8b728c).title, {
            inviteeCount: invitees.length
        })),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            as: "p"
        }, invitees.length === 1 ? formatMessage((0, $51c0b753466c6f65$export$defe85febe8b728c).descriptionGenericOne, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeEmailOrName: inviteeEmailOrName,
            productDisplayName: productDisplayName
        }) : formatMessage((0, $51c0b753466c6f65$export$defe85febe8b728c).descriptionGenericPlural, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: invitees.length,
            productDisplayName: productDisplayName
        }))
    });
});
const $7efa8cd547614dec$var$footerStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    transform: 'translateX(2px)'
});
const $7efa8cd547614dec$var$subtleColorStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});


const $7146eac021ae0da8$var$PRODUCT = 'jira-software';
const $7146eac021ae0da8$export$c323779e5ddf45d0 = (flags)=>{
    return (0, $cozmU.useCallback)((invitees)=>{
        const dismiss = (id)=>flags?.hideFlag(id);
        flags?.showFlag({
            customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7efa8cd547614dec$export$6c436beee6e5593), {
                    ...props,
                    id: props.id,
                    invitees: invitees,
                    product: $7146eac021ae0da8$var$PRODUCT,
                    onDismiss: dismiss
                })
        });
    }, [
        flags
    ]);
};















var $24dy7 = parcelRequire("24dy7");










const $b25e3691fc65d32d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "invite-prompt.invite-error-flag.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "invite-prompt.invite-error-flag.description",
        defaultMessage: "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        id: "invite-prompt.invite-error-flag.action",
        defaultMessage: "Contact support"
    }
});


const $689d53c76dd279fd$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $689d53c76dd279fd$export$92c0939d1a977673 = (0, $a32b880d9fff35bb$export$2a4cd3780f93f2ef)(({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            as: "p",
            xcss: $689d53c76dd279fd$var$subtleColorStyles
        }, formatMessage((0, $b25e3691fc65d32d$export$defe85febe8b728c).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            as: "p",
            xcss: $689d53c76dd279fd$var$subtleColorStyles
        }, formatMessage((0, $b25e3691fc65d32d$export$defe85febe8b728c).description)),
        actions: [
            {
                content: formatMessage((0, $b25e3691fc65d32d$export$defe85febe8b728c).action),
                href: $689d53c76dd279fd$var$SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
});
const $689d53c76dd279fd$var$subtleColorStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});


const $ae2d7893dd4ac2c9$export$e6d35b1c4e81af0e = (flags)=>{
    return (0, $cozmU.useCallback)(()=>{
        const dismiss = (id)=>flags?.hideFlag(id);
        flags?.showFlag({
            customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $689d53c76dd279fd$export$92c0939d1a977673), {
                    ...props,
                    id: props.id,
                    onDismiss: dismiss
                })
        });
    }, [
        flags
    ]);
};


const $bd2b44989bfef37e$var$PRODUCT = 'jira-software';
const $bd2b44989bfef37e$var$MAX_NUMBER_OF_INVITEES = 10;
const $bd2b44989bfef37e$export$ce7c2ea6d33a7cf4 = (flags)=>{
    const invite = (0, $f0af817f11d386cd$export$359310a05698289)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const showSuccessFlag = (0, $7146eac021ae0da8$export$c323779e5ddf45d0)(flags);
    const showErrorFlag = (0, $ae2d7893dd4ac2c9$export$e6d35b1c4e81af0e)(flags);
    return (0, $cozmU.useCallback)((invitees, targetTitle, continueUrl, jiraCloudId, pageVersion)=>{
        const attributes = {
            invitees: invitees.length,
            pageVersion: pageVersion
        };
        const onDismissFlag = (attributes)=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'dismissFlag',
                    source: 'inviteOnLinkInsert',
                    attributes: attributes
                }
            }).fire();
            (0, $0fd2f9e99abe54b2$export$df91f816b0924368)();
        };
        const onOptOutFlag = (id, attributes, flags)=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'optOutFlag',
                    source: 'inviteOnLinkInsert',
                    attributes: attributes
                }
            }).fire();
            flags?.hideFlag(id);
            (0, $0fd2f9e99abe54b2$export$e0a1da35077dec46)();
        };
        flags?.showFlag({
            customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e168de3e4fd2412a$export$d6bef3efd7271258), {
                    ...props,
                    id: props.id,
                    invitees: invitees.slice(0, $bd2b44989bfef37e$var$MAX_NUMBER_OF_INVITEES),
                    targetTitle: targetTitle,
                    targetProduct: $bd2b44989bfef37e$var$PRODUCT,
                    onDismiss: ()=>{
                        onDismissFlag(attributes);
                    },
                    onOptOut: (0, $0fd2f9e99abe54b2$export$c509de4446dd8f14)() ? ()=>{
                        onOptOutFlag(props.id, attributes, flags);
                    } : undefined,
                    onSubmit: async ()=>{
                        const response = await invite({
                            continueUrl: continueUrl,
                            users: invitees.map(({ id: id })=>({
                                    id: id
                                })),
                            touchpoint: 'Prompt invite on link insert',
                            integration: 'invitePromptOnLink',
                            resources: [
                                (0, $7avaU.AnyAri).create({
                                    resourceOwner: $bd2b44989bfef37e$var$PRODUCT,
                                    resourceType: 'site',
                                    resourceId: jiraCloudId
                                })
                            ]
                        });
                        flags.hideFlag(props.id);
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'addPeople',
                                source: 'inviteOnLinkInsert',
                                attributes: attributes
                            }
                        }).fire();
                        const { error: error, failure: failure } = (0, $4wqa6.mapInviteResult)(response);
                        if (error.length > 0 || failure) {
                            showErrorFlag();
                            return;
                        }
                        showSuccessFlag(invitees);
                    }
                })
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'flag',
                actionSubjectId: 'invitePromptFlag',
                source: 'inviteOnLinkInsert',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        flags,
        invite,
        showErrorFlag,
        showSuccessFlag
    ]);
};


const $706402d3689c35f7$export$dccc074766ad40ea = (flags)=>{
    const { store: store } = (0, $cMyWi.useSmartLinkContext)();
    const { cloudId: confluenceCloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)(async (pageId, content, pageVersion, startingLinks)=>{
        if (startingLinks === undefined || flags === undefined) return;
        try {
            const newLinkData = (0, $8Tj57.getJiraSmartLinks)(content, store);
            for (const [link, data] of Object.entries(newLinkData))if (!startingLinks?.has(link)) {
                const { tenantId: jiraCloudId, name: name } = data;
                const invitees = await (0, $a79c3911132ae713$export$5f5d669200f1eee2)({
                    userId: userId,
                    confluenceCloudId: confluenceCloudId,
                    pageId: pageId,
                    jiraCloudId: jiraCloudId
                });
                if (invitees.length > 0) {
                    if ((0, $0fd2f9e99abe54b2$export$ba6b48d01450a592)()) return;
                    return {
                        invitees: invitees,
                        targetTitle: name,
                        continueUrl: link,
                        jiraCloudId: jiraCloudId,
                        pageVersion: pageVersion
                    };
                }
                break;
            }
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'checkEligibility',
                    source: 'inviteOnLinkInsert',
                    attributes: {
                        message: String(error),
                        details: {
                            ...error
                        }
                    }
                }
            }).fire();
        }
    }, [
        confluenceCloudId,
        createAnalyticsEvent,
        flags,
        store,
        userId
    ]);
};
const $706402d3689c35f7$export$dbbe7a57db836ddc = (flags)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const showInviteFlag = (0, $bd2b44989bfef37e$export$ce7c2ea6d33a7cf4)(flags);
    return (0, $cozmU.useCallback)(async ({ invitees: invitees, targetTitle: targetTitle, continueUrl: continueUrl, jiraCloudId: jiraCloudId, pageVersion: pageVersion })=>{
        try {
            showInviteFlag(invitees, targetTitle, continueUrl, jiraCloudId, pageVersion);
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'showInviteFlag',
                    source: 'inviteOnLinkInsert',
                    attributes: {
                        message: String(error),
                        details: {
                            ...error
                        }
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        showInviteFlag
    ]);
};
module.exports["useInviteOnLinkInsertEligibilityCheck"] = $706402d3689c35f7$export$dccc074766ad40ea;
module.exports["useShowInviteOnLinkInsertFlag"] = $706402d3689c35f7$export$dbbe7a57db836ddc;

});


//# sourceMappingURL=FullPageEditorComponent.c5472607.js.map
